export const monitors_en = {
  off_company_enrichment_desc: "Off — matches include the company name and signal only",
  add_company_details: "Add company details",
  off_people_search_desc: "Off — not finding contacts at matched companies",
  add_people_search: "Add people search",
  monitor_flow_sequence_deleted_title:
    "The assigned sequence was <span>deleted</span>, so this monitor has no destination. It was set to <span>Inactive</span> and will not deliver matched records until you connect a new destination.",
  monitor_create_delivery_sequence_warning_assign_button:
    "Assign a new destination",
  // data export
  monitors_download_data_include: "Include",
  monitors_download_data_records: "{0} records",
  monitors_download_data_layout: "Layout",
  monitors_download_data_layout_one_sheet: "One sheet",
  monitors_download_data_layout_one_sheet_desc:
    "Row per company, people joined",
  monitors_download_data_layout_separate: "Separate files",
  monitors_download_data_layout_separate_desc: "One file per type (.zip)",
  monitors_download_data_summary: "≈ {0} rows · CSV",
  monitors_download_data_truncated: "export cap reached — narrow the range",
  monitors_export_logs_title: "Trigger logs",
  monitors_export_logs_desc: "Status, credits & raw payloads",
  monitors_export_data_title: "Signal data",
  monitors_export_data_desc: "Companies, people & signals",
  monitors_download_data_title: "Download data",
  monitors_download_data_desc:
    "Export the signals, companies and people behind each trigger — the same data your destination receives.",
  monitors_download_data_type: "Data type",
  monitors_download_data_type_companies: "Companies",
  monitors_download_data_type_signals: "Signals",
  monitors_download_data_type_people: "People",
  monitors_download_data_scope: "Scope",
  monitors_download_data_scope_selected: "Selected triggers ({0})",
  monitors_download_data_scope_range: "Date range",
  monitors_download_data_range_start: "Start date",
  monitors_download_data_range_end: "End date",
  monitors_download_data_people_hint:
    "People rows appear only when this monitor enriches people.",
  monitors_download_data_confirm: "Download CSV",
  // list
  monitors_list_item_statistic_tiggers_today: "Triggers today",
  monitors_list_item_statistic_tiggers_today_desc: "{0}% from yesterday",
  monitors_list_item_statistic_last_trigger: "Last triggered",
  monitors_list_item_statistic_today_trigger_count: "Today",
  monitors_list_item_statistic_success_rate: "Success",
  avg_per_day: "Avg per day",
  last_7_days: "Last 7 days",
  success_rate: "Success rate",
  monitors_list_aside_skeleton_content:
    "Create your first monitor to start tracking signals and getting notified when something matches.",

  //   create
  save_draft_and_exit: "Save draft and exit",
  monitors_draft_system_name: "{subject} — Draft · {date}",
  back_to_monitors: "Back to monitor list",
  monitors_create_title: "Set up a monitor",
  monitors_create_header_desc: "Name this monitor in Step 4 (Preview)",
  monitors_edit_header_desc: "Rename this monitor in Step 4 (Preview)",
  new_monitor: "New monitor",
  monitors_create_flow_title: "Monitor Flow",
  monitors_create_step_trigger: "Trigger",
  monitors_create_step_enrichment: "Enrichment",
  monitors_create_step_delivery: "Delivery",
  monitors_create_step_preview: "Preview",
  monitor_create_bottom_desc:
    "Step <span class='monitors-container-create-bottom-desc-heavy'>{step}</span> of {step_total} · <span class='monitors-container-create-bottom-desc-heavy'>{step_name}</span> {step_desc}",

  monitors_create_step_trigger_desc: "Choose what to watch for.",
  monitors_create_step_enrichment_desc:
    "Optionally add company info or contacts.",
  monitors_create_step_delivery_desc: "Pick where matches are sent.",
  monitors_create_step_preview_desc: "Review everything, then create.",

  //  create trigger
  monitors_create_signal_trigger_header_title: "Signal trigger",
  monitors_create_signal_trigger_header_desc:
    "A signal is an event at a company. This trigger decides what starts your monitor.",

  monitors_create_signal_trigger_detection_mode_title: "Detection mode",
  monitors_create_signal_trigger_detection_mode_desc:
    " — What do you want to start from?",
  signal_first: "Signal first",
  monitors_create_signal_trigger_detection_mode_signal_first_title:
    "A type of event",
  monitors_create_signal_trigger_detection_mode_signal_first_desc:
    "Watch for things like news, hiring, or expansion across any company that matches your filters.",
  monitors_create_signal_trigger_detection_mode_signal_first_eg:
    "e.g. <span>Any company hiring Sales in MY, or any company running Ads in APAC with size > 100</span>",
  company_first: "Company first",
  monitors_create_signal_trigger_detection_mode_company_first_title:
    "Specific companies I know",
  monitors_create_signal_trigger_detection_mode_company_first_desc:
    "Pick companies you already care about and get alerted when any signal fires for them.",
  monitors_create_signal_trigger_detection_mode_company_first_eg:
    "e.g. <span>Monitor Amazon & Google for News in new regions, or Jobs in Hong Kong</span>",
  monitors_create_signal_trigger_signal_types_label: "SIGNAL TYPES",
  monitors_create_signal_trigger_signal_types_label_addition: " — What events?",
  monitors_create_signal_trigger_signal_types_tips:
    "Each signal triggers independently—you’ll be notified when any of them fires. They don’t need to occur at the same time.",

  monitor_create_signal_breakdown: "<span>NARROW IT DOWN</span>  · Optional",
  monitor_create_signal_breakdown_desc:
    "Optional — add filters for fewer, more specific matches.",

  condition_count: "0 Conditions | 1 Condition | {count} Conditions",

  monitors_create_signal_trigger_company_filter_title:
    "Which companies qualify",
  monitors_create_signal_trigger_company_filter_tag: "Applies to all signals",
  monitors_create_signal_trigger_company_filter_desc:
    "Company attributes like size, industry, HQ country, or tech stack.",

  monitors_create_signal_trigger_company_monitor_title: "Companies to monitor",
  monitors_create_signal_trigger_company_monitor_placeholder:
    "Add multiple companies...",
  add_filter_condition: "Add filter condition",
  monitors_create_signal_trigger_company_filter_label: "COMPANY CRITERIA",
  monitors_create_signal_trigger_company_filter_label_addition:
    " — For which companies?",
  monitors_create_signal_trigger_signal_filter_label: "SIGNAL CONDITIONS",
  monitors_create_signal_trigger_signal_filter_label_addition:
    " — Any specific event details?",
  monitors_create_signal_trigger_max_record_title: "Max companies per trigger",
  monitors_create_signal_trigger_max_record_desc:
    "Limits how many matched companies are processed per trigger. Enrichment and people search run on each record — this cap prevents unexpected credit spend when signals are broad.",

  tabNews_desc: "A company is in the news",
  tabJobPostings_desc: "A company is hiring",
  ads_desc: "A company starts advertising",
  expansions_desc: "A company is growing or expanding",

  monitors_create_signal_trigger_max_record_tips:
    "Set in step 1 — go back to change",
  monitors_create_signal_trigger_detection_mode_warning_1:
    "Global filters cleared",
  monitors_create_signal_trigger_detection_mode_warning_2:
    "Recent matches reset",
  monitors_create_signal_trigger_detection_mode_warning_3:
    "Webhook payload changed",
  monitors_create_signal_trigger_detection_mode_switch_to_signal_first:
    "Switch to signal first",
  monitors_create_signal_trigger_detection_mode_switch_to_company_first:
    "Switch to company first",
  //   create enrichment
  monitors_create_enrichment_header_title: "Enrichment & validation",
  monitors_create_enrichment_header_desc:
    "Optionally enrich signal data or apply AI conditions before delivery",
  monitors_create_enrichment_company_details_title: "Company details",
  monitors_create_enrichment_company_details_cost:
    "0 credits per company | 1 credit per company | {count} credits per company",

  monitors_matched_deliver_company_detail_desc:
    "Shown as a full company profile in the {destination}",

  monitors_create_enrichment_company_details_desc:
    "Adds firmographics — company size, industry, HQ location, and a short profile — to every matched company.",
  monitors_create_enrichment_company_details_tips:
    "<span>Best for</span> qualifying or routing by company fit. <span>Leave off</span> if you already know the companies.",

  monitors_create_enrichment_people_search_title: "People search ",

  monitors_create_enrichment_people_search_cost:
    "0 credits per search | 1 credit per search | {count} credits per search",
  monitors_create_enrichment_people_search_desc:
    "Finds real people at each matched company by role, then optionally gets their email and phone.",

  monitors_create_enrichment_people_search_tips:
    "<span>Best for</span> outreach you want to start automatically. <span>Leave off</span> if you only need to know which companies are active.",
  monitors_create_enrichment_people_search_config_item_max_people_to_return:
    "Max people to return",

  monitors_create_enrichment_people_search_config_item_redeem_contact_info:
    "Redeem contact info",
  monitors_create_enrichment_people_search_config_item_redeem_credits:
    "0 credits per person | 1 credit per person | {count} credits per person",
  monitors_create_enrichment_people_search_config_add_one:
    "Add another people search",
  monitors_create_enrichment_people_search_config_tips:
    "Each search runs independently. A search fee is charged per search, with email and phone redemption charged separately per person returned.",
  monitors_create_enrichment_people_search_config_item_advanced_title:
    "<span>Advanced filters</span>  · Optional",
  monitors_create_enrichment_people_search_config_item_advanced_desc:
    "Narrow to people already in a list or sequence",
  monitors_create_enrichment_people_search_config_item_advanced_tips:
    "Only return people who are <span>already</span> in a list or sequence. Leave blank to search everyone. Useful for re-engagement.",
  monitors_create_enrichment_people_search_config_item_advanced_label_saved_list:
    "Already in saved list",
  monitors_create_enrichment_people_search_config_item_advanced_label_sequence:
    "Already in sequence",

  // create-delivery
  destination_type: "Destination type",
  monitors_create_delivery_title: "Where should matches go?",
  monitors_create_delivery_desc:
    "Choose the destination and how often we check.",
  monitors_create_delivery_type_next_release: "v2.0",
  webhook: "Webhook",
  monitors_create_delivery_type_webhook_desc:
    "Push signal data to your own system or third-party tools",
  monitors_create_delivery_type_email_title: "Email",
  monitors_create_delivery_type_email_desc:
    "Receive a readable summary of matched signals by email",
  monitors_create_delivery_type_sequences_title: "Sequences",
  monitors_create_delivery_type_sequences_desc:
    "Auto-enroll matched contacts into an outreach sequence",
  monitors_create_delivery_type_sheets_title: "Sheets",
  monitors_create_delivery_type_sheets_desc:
    "Sync matched signals to your preferred data destination",

  monitors_create_delivery_configuration_webhook: "Webhook configuration",
  monitors_create_delivery_configuration_email: "Email configuration",
  monitors_create_delivery_configuration_sequences: "Sequences configuration",
  monitors_create_delivery_configuration_sheets: "Sheets configuration",

  monitors_create_delivery_email_send_to_label: "Send to",
  monitors_create_delivery_email_send_to_placeholder: "johndoe@example.com",
  monitors_create_delivery_configuration_webhook_endpoint_url: "Endpoint URL",
  monitors_create_delivery_configuration_webhook_endpoint_url_placeholder:
    "https://your-webhook.site",
  monitors_create_delivery_headers: "Headers",
  optional: "Optional",
  monitors_create_delivery_add_headers: "Add header",
  monitors_create_delivery_body: "Body parameters",
  monitors_create_delivery_add_body: "Add parameter",
  monitors_create_key: "Key",
  monitors_create_value: "Value",
  monitors_create_delivery_alert_message_label: "Failure alert email",
  monitors_create_delivery_alert_message_placeholder:
    "Notify this address if the endpoint fails",
  monitors_create_delivery_run_test_webhook_title: "Validate endpoint",
  monitors_create_delivery_run_test_webhook_desc:
    "Send a test payload to confirm your server is receiving correctly",
  monitors_create_delivery_run_test_email_title: "Validate email",
  monitors_create_delivery_run_test_email_desc:
    "Send a test email to confirm your address is receiving correctly",
  monitors_create_delivery_run_test_button: "Send test",

  monitors_create_header_key_placeholder: "e.g Authorization",
  monitors_create_header_value_placeholder: "e.g Bearer your token",

  //   create preview
  monitors_create_preview_title: "Review & create",
  monitors_create_preview_desc: "Confirm your setup before going live",
  monitors_create_preview_define_name_title: "Monitor name ",
  monitors_create_preview_define_name_placeholder:
    "e.g Hiring - Sales in MY (foreign cos, 100+)",
  monitors_create_preview_tips:
    "Your API key (X-Pubrio-Signature) will be generated after creation and shown immediately in the Settings tab.",

  monitors_create_preview_summary:
    "This monitor watches for <span>{signals}</span> at <span>{companies}</span>, then sends matches <span>{destination}</span>, checked in {interval}.",
  any_matching_companies: "any matching company",

  // detail settings
  monitor: "monitor",
  monitors: "Monitors",
  delivery: "DELIVERY",
  sync_interval: "Sync interval",
  sync_interval_description: "How often to check for new signals",
  alert_email: "Alert email",
  alert_email_description:
    "We’ll email you for any failures and when this monitor gets auto-paused",

  failure_handle: "Failure handling",
  failure_handle_retry_attempts: "Retry attempts",
  failure_handle_retry_attempts_desc:
    "How many times to retry before marking a delivery as failed",
  failure_handle_retry_delay: "Retry delay",
  failure_handle_retry_delay_desc:
    "How long to wait between each retry attempt",
  failure_handle_auto_pause_failures_count:
    "Auto-pause after consecutive failures",
  failure_handle_auto_pause_failures_count_desc:
    "Pubrio will deactivate this monitor automatically to prevent credit waste. You'll receive a failure alert email",
  failure_handle_daily_trigger_cap: "Daily trigger cap",
  failure_handle_daily_trigger_cap_desc:
    "Maximum triggers per day — helps control credit spend. 0 = unlimited",
  security: "security",
  monitors_list_detail_settings_security_api_key_title:
    "API key (X-Pubrio-Signature)",
  monitors_list_detail_settings_security_api_key_description:
    "Add this to your server-side verification logic",
  copied: "Copied",

  //   detail tabs
  monitors_detail_tab_flow: "Flow",

  // wizard
  getting_started: "Getting started",
  monitors_wizard_introduction_title:
    "Track signals and route the matches automatically",
  monitors_wizard_introduction_desc:
    "A monitor watches for the signals you care about — hiring, news, ads, funding — then enriches each match and sends it wherever you work. Set one up in three steps.",
  // Wizard guided tour (driver.js)
  monitor_wizard_tour_step_1_title: "Welcome — let's catch buying signals",
  monitor_wizard_tour_step_1_desc:
    "A monitor watches companies for signals like hiring or funding, then alerts you the moment one matches. Let's build your first one.",
  monitor_wizard_tour_step_2_title: "Start with what to watch",
  monitor_wizard_tour_step_2_desc:
    "Pick the signals that matter: hiring, news, ads and expansion. We'll alert you whenever any of them fires.",
  monitor_wizard_tour_step_3_title: "Watch it take shape",
  monitor_wizard_tour_step_3_desc:
    "This live preview shows your monitor as a pipeline, including what triggers it, what we add, and where it goes.",
  monitor_wizard_tour_step_4_title: "Add the detail you'll use",
  monitor_wizard_tour_step_4_desc:
    "Turn on company info or real contacts so every match is ready for action, not just a name.",
  monitor_wizard_tour_step_5_title: "Send matches where you work",
  monitor_wizard_tour_step_5_desc:
    "Email, a sequence, a spreadsheet, or your own tools. Choose where you want to act on the matches.",
  monitor_wizard_tour_step_6_title: "See exactly what you'll get",
  monitor_wizard_tour_step_6_desc:
    "This panel always shows what each match delivers, so you know the value before you finish.",
  monitor_wizard_tour_step_7_title: "You're ready! create it!",
  monitor_wizard_tour_step_7_desc:
    "Step through the last screen and hit Create. Your monitor goes live and starts catching signals.",
  monitors_wizard_tips: "Takes about 2 minutes to set up",
  create_first_monitor: "Create your first monitor",

  monitors_trigger_types_str: "Jobs · News · Advertisements",
  custom_interval: "Custom interval",
  monitors_wizard_define_trigger_title: "Define your trigger",
  monitors_wizard_define_trigger_desc:
    "Choose which signals to watch for and set filters to narrow the match. Track any company or a specific set.",
  monitors_wizard_enrich_signal_data_title: "Enrich the signal data",
  monitors_wizard_enrich_signal_data_desc:
    "Optionally append company details or run people searches to find the right contacts at matched companies.",
  monitors_wizard_choose_destination_title: "Choose your destination",
  monitors_wizard_choose_destination_desc:
    "Send matched signal data to a webhook, email, or connected tool. Set the sync interval — from real-time to daily.",
  monitors_wizard_example_title: "example monitors",

  presets: "Presets",

  // flow
  monitors_flow_company_enrichment: "Company enrichment",
  destination: "Destination",
  add_filter: "Add filter",
  field: "field",
  operator: "operator",
  real_time: "Real time",

  monitors_create_company_first_one_company_at_least:
    "Please add at least one company to monitor.",
  monitors_create_signal_types_one_at_least:
    "Please select at least one signal type to continue.",
  monitors_create_validation_signal_types_required:
    "Pick at least one signal type to watch for.",
  monitors_create_validation_email_required:
    "Add at least one recipient email address.",
  monitors_create_validation_name_required:
    "Give your monitor a name so you can find it later.",

  // try
  monitor_try_popover_title: "Try this monitor",
  monitor_try_popover_desc:
    "Pick a date to run against. Credits are consumed if results are found.",
  monitor_try_popover_form_date_label: "Date",
  monitor_try_popover_max_results_label: "Max results",
  run_query: "Run query",
  monitors_try_button: "Run test query",

  // list aside filters
  last_trigger_at_descending: "Last Triggered (Newest First)",
  last_trigger_at_ascending: "Last Triggered (Oldest First)",
  name_ascending: "Name (A-Z)",
  name_descending: "Name (Z-A)",

  // signals
  news: "News",
  jobs: "Jobs",
  signal_types: "Signal types",
  news_filter: "News filters",
  jobs_filter: "Jobs filters",
  advertisements_filter: "Advertisements filters",
  global_filters: "Company filters",

  company_enrichment_enable_desc: "Size, industry, HQ, profile added",
  company_enrichment_enable_fields: "Size, industry, HQ, profile",
  off: "Off",

  max_people_count: "Max 0 people | Max 1 person | Max {count} people",
  "monitor_detail_logs-table-empty-title": "No logs yet",
  "monitor_detail_logs-table-empty-desc":
    "Logs will appear once this monitor starts receiving signals. Try running a test query to trigger your first event.",

  signal: "Signal",
  detection: "Detection",
  monitor_detail_logs_payload_sent: "payload sent",
  monitor_detail_logs_payload_received: "response",
  monitor_detail_logs_trigger_config: "trigger config",

  create_monitor: "Create monitor",
  update_monitor: "Update monitor",

  monitors_edit_title: "Edit monitor",
  global: "Global",
  navMonitorsDesc:
    "Track companies and get notified when there's a reason to contact them.",

  trigger_limits: "TRIGGER LIMITS",

  recovered: "Recovered",

  monitor_not_found: "Monitor not found",
  please_select_field_and_operator_first:
    "Please select field and operator first",

  people_count: "0 people | 1 person | {count} people",
  search_fee: "{0} search fee",
  credits_cost: "0 credits | 1 credit | {count} credits ",
  email_cost: "{0} email",
  phone_cost: "{0} phone",
  estimated_cost: "Estimated cost:",
  monitors_create_enrichment_people_search_config_item_credits_message:
    "Estimated cost: min <strong>{0}</strong>, max <strong>{1}</strong> = {2}",

  monitor_estimate_cost_title: "EST. COST PER TRIGGER",
  monitor_estimate_cost_max_record:
    "max 0 records | max 1 record | max {count} records",
  credits_cost_range: "{0} credits",
  signal_detection: "Signal detection",
  matched_companies:
    "0 matched companies | 1 matched company | {count} matched companies",
  min_prefix: "Min",
  max_prefix: "Max",

  breakdown: "Breakdown",
  monitor_estimate_cost_fixed_per_trigger: "FIXED PER TRIGGER",
  credits_cost_short: "0 cr | 1 cr | {count} cr",
  credits_cost_short_per_company: "0 cr / co. | 1 cr / co. | {count} cr / co.",
  monitor_estimate_cost_per_match_company: "PER MATCHED COMPANY",
  monitor_estimate_cost_per_company_subtotal: "Per company subtotal",
  monitor_estimate_cost_redeem_cost: "REDEEM COST PER MATCHED COMPANY",
  monitor_estimate_cost_redeem_subtotal: "Redeem subtotal",
  monitor_estimate_cost_redeem_list_name: "PS{0} {1} × {2} ppl",
  monitor_estimate_cost_fixed_desc:
    "Signal detection is a fixed cost — paid once per trigger regardless of how many companies match.",
  monitor_estimate_cost_fixed: "fixed cost",
  redeems: "redeems",
  company_count_short: "0 co. | 1 co. | {count} co.",

  monitor_sequence_summary_step_count: "0 steps | 1 step | {count} steps",
  monitor_sequence_summary_contact_count:
    "0 contacts | 1 contact | {count} contacts",
  search_sequence: "Search sequences",
  create_new_sequence: "Create a new sequence",
  draft: "Draft",

  monitors_create_delivery_sequence_who_enrolled_title: "Who gets enrolled",
  monitors_create_delivery_sequence_edit_in_enrichment: "Edit in enrichment",
  monitors_create_delivery_sequence_who_enrolled_tip:
    "Sources configured in Enrichment. Ticked each on or off for sequence enrollment — criteria is set in Enrichment, not here.",
  monitor_create_delivery_sequence_company_contact: "Company contact",
  monitor_create_delivery_sequence_company_contact_desc:
    "Best match profile · From company profile",
  enrolling: "Enrolling",
  not_enrolling: "Not enrolling",
  monitor_sequence_who_enrolled_people_title: "PEOPLE  - FROM PEOPLE SEARCH",
  monitor_create_delivery_sequence_enroll_behavior_title: "Enrollment behavior",
  monitor_create_delivery_sequence_enroll_behavior_desc:
    "Define what happens in each contact scenario. All rules apply across every enrolled source.",

  monitor_create_delivery_sequence_enroll_behavior_new_contact_title:
    "New contact",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_desc:
    "Not enrolled in this sequence yet",
  start_at: "Start at",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_placeholder:
    "e.g. Step 1 or Step 2",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_title:
    "Already in target sequence",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_desc:
    "Active in the exact sequence this monitor uses",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_placeholder:
    "e.g. Restart at Step 1",
  skip: "Skip",
  people_search: "People search",
  no_config_in_enrichment: "Not configured in Enrichment",
  fetch_sequence_steps_failed: "Failed to fetch sequence steps",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_option:
    "Step {index} - {step}",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_option:
    "Restart at step {index} - {step}",
  monitors_matched_deliver_signal_title: "Company & signal",
  monitors_matched_deliver_signal_desc:
    "Company name plus the signal that triggered the match",
  monitors_matched_deliver_people_search_desc:
    "Listed in the email with name, title & contact info",
  monitors_matched_deliver_title: "EACH MATCH DELIVERS",
  to_somewhere: "to {destination}",
  monitor_create_delivery_sequence_people_contact: "People contacts",
  monitor_create_delivery_sequence_people_contact_desc:
    "From all active People Search blocks",
  selected_sequence_not_exist: "Selected sequence does not exist",

  monitors_create_delivery_sequence_enrichment_invalid:
    "Please enroll People contacts, Company contact, or both.",
  monitors_create_delivery_sequence_required:
    "Please select a sequence to continue.",

  failing: "Failing",
  monitor_create_delivery_sequence_warning_title: "Unknown sequence",
  monitor_create_delivery_sequence_warning_desc:
    "Sequence deleted — select a replacement",
  deleted: "Deleted",
  owner: "Owner",
  not_triggered_yet: "Not triggered yet",
};

export const monitors_zhHk = {
  off_company_enrichment_desc: "關閉 —— 符合項目僅包含公司名稱與訊號",
  add_company_details: "新增公司詳情",
  off_people_search_desc: "關閉 —— 不在符合的公司中尋找聯絡人",
  add_people_search: "新增人物搜尋",
  monitor_flow_sequence_deleted_title:
    "指派的序列已被<span>刪除</span>，因此此監察器沒有傳送目的地。它已被設為<span>停用</span>，在你連接新的目的地前將不會傳送符合的記錄。",
  monitor_create_delivery_sequence_warning_assign_button: "指派新的目的地",
  // data export
  monitors_download_data_include: "包含",
  monitors_download_data_records: "{0} 筆記錄",
  monitors_download_data_layout: "格式",
  monitors_download_data_layout_one_sheet: "單一表格",
  monitors_download_data_layout_one_sheet_desc: "每間公司一列，人物合併",
  monitors_download_data_layout_separate: "分開檔案",
  monitors_download_data_layout_separate_desc: "每類一個檔案（.zip）",
  monitors_download_data_summary: "約 {0} 列 · CSV",
  monitors_download_data_truncated: "已達匯出上限 — 請縮窄範圍",
  monitors_export_logs_title: "觸發記錄",
  monitors_export_logs_desc: "狀態、點數及原始內容",
  monitors_export_data_title: "訊號數據",
  monitors_export_data_desc: "公司、人物及訊號",
  monitors_download_data_title: "下載數據",
  monitors_download_data_desc:
    "匯出每次觸發背後的訊號、公司及人物——即您的目的地所收到的數據。",
  monitors_download_data_type: "數據類型",
  monitors_download_data_type_companies: "公司",
  monitors_download_data_type_signals: "訊號",
  monitors_download_data_type_people: "人物",
  monitors_download_data_scope: "範圍",
  monitors_download_data_scope_selected: "已選觸發 ({0})",
  monitors_download_data_scope_range: "日期範圍",
  monitors_download_data_range_start: "開始日期",
  monitors_download_data_range_end: "結束日期",
  monitors_download_data_people_hint:
    "只有當此監測啟用人物增強時，才會出現人物資料。",
  monitors_download_data_confirm: "下載 CSV",
  // list
  monitors_list_item_statistic_tiggers_today: "今日觸發次數",
  monitors_list_item_statistic_tiggers_today_desc: "較昨日 {0}%",
  monitors_list_item_statistic_last_trigger: "上次觸發",
  monitors_list_item_statistic_today_trigger_count: "今日",
  monitors_list_item_statistic_success_rate: "成功率",
  avg_per_day: "日均",
  last_7_days: "過去 7 天",
  success_rate: "成功率",
  monitors_list_aside_skeleton_content:
    "建立第一個監察器，開始追蹤訊號，並在條件命中時即時收到通知。",

  //   create
  save_draft_and_exit: "儲存草稿並離開",
  monitors_draft_system_name: "{subject} — 草稿 · {date}",
  back_to_monitors: "返回監察器列表",
  monitors_create_title: "設定監察器",
  monitors_create_header_desc: "在步驟 4（預覽）為此監察器命名",
  monitors_edit_header_desc: "在步驟 4（預覽）重新命名此監察器",
  new_monitor: "新增監察器",
  monitors_create_flow_title: "監察流程",
  monitors_create_step_trigger: "觸發條件",
  monitors_create_step_enrichment: "資料增補",
  monitors_create_step_delivery: "傳送方式",
  monitors_create_step_preview: "預覽",
  monitor_create_bottom_desc:
    "步驟 <span class='monitors-container-create-bottom-desc-heavy'>{step}</span>／共 {step_total} 步 ·  <span class='monitors-container-create-bottom-desc-heavy'>{step_name}</span> {step_desc}",

  monitors_create_step_trigger_desc: "選擇要關注的內容。",
  monitors_create_step_enrichment_desc: "可選擇加入公司資訊或聯絡人。",
  monitors_create_step_delivery_desc: "選擇符合項目的傳送位置。",
  monitors_create_step_preview_desc: "檢視所有設定，然後建立。",

  //  create trigger
  monitors_create_signal_trigger_header_title: "訊號觸發",
  monitors_create_signal_trigger_header_desc:
    "訊號是公司發生的事件。此觸發條件決定什麼會啟動您的監察器。",

  monitors_create_signal_trigger_detection_mode_title: "偵測模式",
  monitors_create_signal_trigger_detection_mode_desc: " —— 您想從什麼開始？",
  signal_first: "訊號優先",
  monitors_create_signal_trigger_detection_mode_signal_first_title:
    "某類型的事件",
  monitors_create_signal_trigger_detection_mode_signal_first_desc:
    "監察任何符合你篩選條件的公司，留意新聞、招聘或擴張等動態。",
  monitors_create_signal_trigger_detection_mode_signal_first_eg:
    "例如：<span>任何在 MY 招聘 Sales 的公司，或任何在 APAC 投放廣告且規模 > 100 的公司</span>",
  company_first: "公司優先",
  monitors_create_signal_trigger_detection_mode_company_first_title:
    "我已知的特定公司",
  monitors_create_signal_trigger_detection_mode_company_first_desc:
    "挑選你已關注的公司，當任何訊號被觸發時收到提醒。",
  monitors_create_signal_trigger_detection_mode_company_first_eg:
    "例如：<span>監察 Amazon 與 Google 在新地區的 News，或香港的 Jobs</span>",
  monitors_create_signal_trigger_signal_types_label: "訊號類型",
  monitors_create_signal_trigger_signal_types_label_addition: " —— 哪些事件？",
  monitors_create_signal_trigger_signal_types_tips:
    "每個訊號會獨立觸發，只要其中一個命中你就會收到通知，無需同時發生。",

  monitor_create_signal_breakdown: "<span>縮小範圍</span>  · 選填",
  monitor_create_signal_breakdown_desc:
    "選填 —— 加入篩選條件，獲得更少但更精準的結果。",

  condition_count: "0 個條件 | 1 個條件 | {count} 個條件",

  monitors_create_signal_trigger_company_filter_title: "哪些公司符合條件",
  monitors_create_signal_trigger_company_filter_tag: "套用至所有訊號",
  monitors_create_signal_trigger_company_filter_desc:
    "公司屬性，例如規模、產業、總部所在國家或技術棧。",

  monitors_create_signal_trigger_company_monitor_title: "要監察的公司",
  monitors_create_signal_trigger_company_monitor_placeholder: "新增多間公司⋯",
  add_filter_condition: "新增篩選條件",
  monitors_create_signal_trigger_company_filter_label: "公司條件",
  monitors_create_signal_trigger_company_filter_label_addition:
    " —— 適用於哪些公司？",
  monitors_create_signal_trigger_signal_filter_label: "訊號條件",
  monitors_create_signal_trigger_signal_filter_label_addition:
    " —— 有任何特定事件細節嗎？",
  monitors_create_signal_trigger_max_record_title: "每次觸發的最大記錄數",
  monitors_create_signal_trigger_max_record_desc:
    "限制每次觸發可處理的符合公司數量。資料增補與人物搜尋會逐筆執行，此上限可避免在廣泛訊號下產生非預期的點數消耗。",

  tabNews_desc: "公司出現在新聞中",
  tabJobPostings_desc: "公司正在招聘",
  ads_desc: "公司開始投放廣告",
  expansions_desc: "公司正在成長或擴張",

  monitors_create_signal_trigger_max_record_tips: "於步驟 1 設定，可返回修改",
  monitors_create_signal_trigger_detection_mode_warning_1: "全域篩選已清除",
  monitors_create_signal_trigger_detection_mode_warning_2: "最近匹配已重設",
  monitors_create_signal_trigger_detection_mode_warning_3:
    "Webhook payload 已變更",
  monitors_create_signal_trigger_detection_mode_switch_to_signal_first:
    "切換為訊號優先",
  monitors_create_signal_trigger_detection_mode_switch_to_company_first:
    "切換為公司優先",
  //   create enrichment
  monitors_create_enrichment_header_title: "資料增補與驗證",
  monitors_create_enrichment_header_desc:
    "可選擇在傳送前增補訊號資料，或套用 AI 條件進行驗證",
  monitors_create_enrichment_company_details_title: "公司資料",
  monitors_create_enrichment_company_details_cost:
    "每次查詢 0 點 | 每次查詢 1 點 | 每次查詢 {count} 點",

  monitors_matched_deliver_company_detail_desc:
    "在 {destination} 中以完整公司檔案顯示",

  monitors_create_enrichment_company_details_desc:
    "為每筆命中的訊號附加規模、產業、總部與公司簡介",
  monitors_create_enrichment_company_details_tips:
    "<span>最適合</span>用於依公司契合度進行篩選或分流。若你已知道目標公司，可<span>關閉</span>。",

  monitors_create_enrichment_people_search_title: "人物搜尋",

  monitors_create_enrichment_people_search_cost:
    "每次搜尋 0 點 | 每次搜尋 1 點 | 每次搜尋 {count} 點",
  monitors_create_enrichment_people_search_desc:
    "可為每筆訊號執行一個或多個人物搜尋，各自擁有獨立篩選條件，結果會分組輸出。",
  monitors_create_enrichment_people_search_tips:
    "<span>最適合</span>用於想自動展開的接觸活動。若你只需知道哪些公司有動態，可<span>關閉</span>。",
  monitors_create_enrichment_people_search_config_item_max_people_to_return:
    "最多返回人數",

  monitors_create_enrichment_people_search_config_item_redeem_contact_info:
    "兌換聯絡資料",
  monitors_create_enrichment_people_search_config_item_redeem_credits:
    "每人 0 點 | 每人 1 點 | 每人 {count} 點",
  monitors_create_enrichment_people_search_config_add_one: "新增一組人物搜尋",
  monitors_create_enrichment_people_search_config_tips:
    "每個搜尋會獨立執行。搜尋費用按每次搜尋計算，電郵與電話兌換則按每位返回聯絡人另行計費。",
  monitors_create_enrichment_people_search_config_item_advanced_title:
    "<span>進階篩選</span>  · 選填",
  monitors_create_enrichment_people_search_config_item_advanced_desc:
    "篩選出已在名單或流程中的人物",
  monitors_create_enrichment_people_search_config_item_advanced_tips:
    "只回傳<span>已經</span>在名單或流程中的人物。留空則搜尋所有人，適合用於再次互動。",
  monitors_create_enrichment_people_search_config_item_advanced_label_saved_list:
    "已在已儲存名單中",
  monitors_create_enrichment_people_search_config_item_advanced_label_sequence:
    "已在流程中",

  // create-delivery
  destination_type: "目的地類型",
  monitors_create_delivery_title: "目的地與傳送",
  monitors_create_delivery_desc: "定義訊號要傳送到哪裡，以及傳送頻率",
  monitors_create_delivery_type_next_release: "v2.0",
  webhook: "Webhook",
  monitors_create_delivery_type_webhook_desc:
    "將訊號資料推送到你的系統或第三方工具",
  monitors_create_delivery_type_email_title: "Email",
  monitors_create_delivery_type_email_desc: "透過電郵接收可閱讀的訊號摘要",
  monitors_create_delivery_type_sequences_title: "Sequences",
  monitors_create_delivery_type_sequences_desc:
    "自動將符合條件的聯絡人加入外聯工作流程",
  monitors_create_delivery_type_sheets_title: "Sheets",
  monitors_create_delivery_type_sheets_desc:
    "將命中的訊號同步到你偏好的資料目的地",

  monitors_create_delivery_configuration_webhook: "Webhook 設定",
  monitors_create_delivery_configuration_email: "Email 設定",
  monitors_create_delivery_configuration_sequences: "Sequences 設定",
  monitors_create_delivery_configuration_sheets: "Sheets 設定",

  monitors_create_delivery_email_send_to_label: "傳送至",
  monitors_create_delivery_email_send_to_placeholder: "johndoe@example.com",
  monitors_create_delivery_configuration_webhook_endpoint_url: "Endpoint URL",
  monitors_create_delivery_configuration_webhook_endpoint_url_placeholder:
    "https://your-webhook.site",
  monitors_create_delivery_headers: "Headers",
  optional: "選填",
  monitors_create_delivery_add_headers: "新增 Header",
  monitors_create_delivery_body: "Body 參數",
  monitors_create_delivery_add_body: "新增參數",
  monitors_create_key: "鍵名",
  monitors_create_value: "鍵值",
  monitors_create_delivery_alert_message_label: "失敗警示電郵",
  monitors_create_delivery_alert_message_placeholder: "當端點失敗時通知此地址",
  monitors_create_delivery_run_test_webhook_title: "驗證端點",
  monitors_create_delivery_run_test_webhook_desc:
    "傳送測試 payload，確認你的伺服器已正確接收",
  monitors_create_delivery_run_test_email_title: "驗證電郵",
  monitors_create_delivery_run_test_email_desc:
    "傳送測試電郵，確認你的地址可正常收信",
  monitors_create_delivery_run_test_button: "傳送測試",

  monitors_create_header_key_placeholder: "例如 Authorization",
  monitors_create_header_value_placeholder: "例如 Bearer your token",

  //   create preview
  monitors_create_preview_title: "檢查並建立",
  monitors_create_preview_desc: "上線前確認你的設定",
  monitors_create_preview_define_name_title: "監察器名稱 ",
  monitors_create_preview_define_name_placeholder:
    "例如：Hiring - Sales in MY（foreign cos, 100+）",
  monitors_create_preview_tips:
    "你的 API 金鑰（X-Pubrio-Signature）會在建立後產生，並立即顯示於 Settings 分頁。",

  monitors_create_preview_summary:
    "此監察器會監察 <span>{companies}</span> 的 <span>{signals}</span>，並將符合項目傳送至 <span>{destination}</span>，以 {interval} 檢查。",
  any_matching_companies: "任何符合的公司",

  // detail settings
  monitor: "監察器",
  monitors: "監察器",
  delivery: "傳送",
  sync_interval: "同步頻率",
  sync_interval_description: "檢查新訊號的頻率",
  alert_email: "警示電郵",
  alert_email_description:
    "當發生任何失敗，或此監察器被自動暫停時，我們會發送電郵通知你",

  failure_handle: "失敗處理",
  failure_handle_retry_attempts: "重試次數",
  failure_handle_retry_attempts_desc: "在將傳送標記為失敗前，最多重試多少次",
  failure_handle_retry_delay: "重試延遲",
  failure_handle_retry_delay_desc: "每次重試之間要等待多久",
  failure_handle_auto_pause_failures_count: "連續失敗後自動暫停",
  failure_handle_auto_pause_failures_count_desc:
    "Pubrio 會自動停用此監察器，以避免浪費點數。你亦會收到失敗警示電郵",
  failure_handle_daily_trigger_cap: "每日觸發上限",
  failure_handle_daily_trigger_cap_desc:
    "每日最多觸發次數，用於控制點數消耗。0 = 無上限",
  security: "安全性",
  monitors_list_detail_settings_security_api_key_title:
    "API 金鑰（X-Pubrio-Signature）",
  monitors_list_detail_settings_security_api_key_description:
    "加入你的伺服器端驗證邏輯",
  copied: "已複製",

  //   detail tabs
  monitors_detail_tab_flow: "流程",

  // wizard
  getting_started: "開始使用",
  monitors_wizard_introduction_title: "追蹤訊號，自動將符合項目進行分流",
  monitors_wizard_introduction_desc:
    "監察器會持續關注您在意的訊號——招聘、新聞、廣告、募資——接著為每筆符合項目補充資訊，並傳送到您工作的任何地方。三個步驟即可完成設定。",
  // Wizard guided tour (driver.js)
  monitor_wizard_tour_step_1_title: "歡迎——一起捕捉購買訊號",
  monitor_wizard_tour_step_1_desc:
    "監察器會持續關注企業的招聘、募資等訊號，一旦有符合項目就立即通知您。讓我們建立您的第一個監察器。",
  monitor_wizard_tour_step_2_title: "先決定要關注什麼",
  monitor_wizard_tour_step_2_desc:
    "挑選您在意的訊號：招聘、新聞、廣告與擴張。只要其中任何一項觸發，我們就會通知您。",
  monitor_wizard_tour_step_3_title: "看著它逐漸成形",
  monitor_wizard_tour_step_3_desc:
    "這個即時預覽會以流程圖呈現您的監察器，包括觸發條件、我們補充的資料，以及傳送的去向。",
  monitor_wizard_tour_step_4_title: "加上您用得到的細節",
  monitor_wizard_tour_step_4_desc:
    "開啟公司資訊或真實聯絡人，讓每筆符合項目不只是名稱，而是可立即行動。",
  monitor_wizard_tour_step_5_title: "把符合項目送到您工作的地方",
  monitor_wizard_tour_step_5_desc:
    "電子郵件、序列、試算表或您自己的工具。選擇您想要處理這些符合項目的位置。",
  monitor_wizard_tour_step_6_title: "清楚看見您會得到什麼",
  monitor_wizard_tour_step_6_desc:
    "這個面板會隨時顯示每筆符合項目提供的內容，讓您在完成前就了解其價值。",
  monitor_wizard_tour_step_7_title: "準備就緒！立即建立！",
  monitor_wizard_tour_step_7_desc:
    "走完最後一個畫面並按下「建立」。您的監察器即會上線，開始捕捉訊號。",
  monitors_wizard_tips: "約 2 分鐘完成設定",
  create_first_monitor: "建立第一個監察器",

  monitors_trigger_types_str: "職位發布 · 新聞 · 廣告",
  custom_interval: "自訂頻率",
  monitors_wizard_define_trigger_title: "定義觸發條件",
  monitors_wizard_define_trigger_desc:
    "選擇要監察的訊號並設定篩選條件以縮窄匹配範圍。你可追蹤任何公司，或指定一組公司。",
  monitors_wizard_enrich_signal_data_title: "增補訊號資料",
  monitors_wizard_enrich_signal_data_desc:
    "可選擇附加公司資料，或執行人物搜尋，找出命中公司的相關聯絡人。",
  monitors_wizard_choose_destination_title: "選擇目的地",
  monitors_wizard_choose_destination_desc:
    "將匹配的訊號資料傳送至 webhook、email 或已連接工具，並設定同步頻率，從即時到每日皆可。",
  monitors_wizard_example_title: "監察器範例",

  presets: "預設方案",

  // flow
  monitors_flow_company_enrichment: "公司資料增補",
  destination: "目的地",
  add_filter: "新增篩選",
  field: "欄位",
  operator: "運算子",
  real_time: "即時",

  monitors_create_company_first_one_company_at_least:
    "請至少加入一家公司作為監察對象。",
  monitors_create_signal_types_one_at_least: "請至少選擇一種訊號類型後再繼續。",
  monitors_create_validation_signal_types_required:
    "請至少選擇一種要監控的訊號類型。",
  monitors_create_validation_email_required: "請新增至少一個收件人電子郵件地址。",
  monitors_create_validation_name_required: "請為監控器命名，方便日後尋找。",
  // try
  monitor_try_popover_title: "試跑此監察器",
  monitor_try_popover_desc: "選擇要回溯執行的日期。如有命中結果，將扣除點數。",
  monitor_try_popover_form_date_label: "日期",
  monitor_try_popover_max_results_label: "最大結果數",
  run_query: "執行查詢",
  monitors_try_button: "執行測試查詢",

  // list aside filters
  last_trigger_at_descending: "上次觸發（最新優先）",
  last_trigger_at_ascending: "上次觸發（最舊優先）",
  name_ascending: "名稱（A-Z）",
  name_descending: "名稱（Z-A）",

  // signals
  news: "新聞",
  jobs: "職位發佈",
  signal_types: "訊號類型",
  news_filter: "News 篩選",
  jobs_filter: "Jobs 篩選",
  advertisements_filter: "Advertisements 篩選",
  global_filters: "全域篩選",

  company_enrichment_enable_desc: "已加入規模、產業、總部與公司簡介",
  company_enrichment_enable_fields: "規模、產業、總部、公司簡介",
  off: "關閉",

  max_people_count: "最多 0 人 | 最多 1 人 | 最多 {count} 人",
  "monitor_detail_logs-table-empty-title": "尚無日誌",
  "monitor_detail_logs-table-empty-desc":
    "當此監察器開始接收訊號後，日誌會顯示於此。可先執行一次測試查詢以觸發第一筆事件。",

  signal: "訊號",
  detection: "偵測",
  monitor_detail_logs_payload_sent: "已傳送 payload",
  monitor_detail_logs_payload_received: "回應",
  monitor_detail_logs_trigger_config: "觸發設定",

  create_monitor: "建立監察器",
  update_monitor: "更新監察器",

  monitors_edit_title: "編輯監察器",
  global: "全域",
  navMonitorsDesc: "追蹤公司，並在出現適合聯絡的時機時收到通知。",

  trigger_limits: "觸發限制",
  monitor_not_found: "找不到監察器",
  please_select_field_and_operator_first: "請先選擇欄位及運算子",

  people_count: "0 位聯絡人 | 1 位聯絡人 | {count} 位聯絡人",
  search_fee: "搜尋費用 {0} 點",
  credits_cost: "0 積分 | 1 積分 | {count} 積分",
  email_cost: "電郵兌換費用 {0} 點",
  phone_cost: "電話兌換費用 {0} 點",
  estimated_cost: "預估成本:",
  monitors_create_enrichment_people_search_config_item_credits_message:
    "預估成本: 最小 <strong>{0}</strong>，最大 <strong>{1}</strong> = {2}",

  monitor_estimate_cost_title: "每次觸發預估成本",
  monitor_estimate_cost_max_record:
    "最多 0 筆記錄 | 最多 1 筆記錄 | 最多 {count} 筆記錄",
  credits_cost_range: "{0} 點",
  signal_detection: "訊號偵測",
  matched_companies: "0 間匹配公司 | 1 間匹配公司 | {count} 間匹配公司",
  min_prefix: "最小: ",
  max_prefix: "最大: ",

  recovered: "已恢復",
  breakdown: "費用明細",
  monitor_estimate_cost_fixed_per_trigger: "每次觸發固定費用",
  credits_cost_short: "0 點 | 1 點 | {count} 點",
  credits_cost_short_per_company: "0 點/公司 | 1 點/公司 | {count} 點/公司",
  monitor_estimate_cost_per_match_company: "每間匹配公司",
  monitor_estimate_cost_per_company_subtotal: "每間公司小計",
  monitor_estimate_cost_redeem_cost: "每間匹配公司兌換費用",
  monitor_estimate_cost_redeem_subtotal: "兌換小計",
  monitor_estimate_cost_redeem_list_name: "PS{0} {1} × {2} 人",
  monitor_estimate_cost_fixed_desc:
    "訊號偵測為固定費用，每次觸發計費一次，與命中公司數量無關。",
  monitor_estimate_cost_fixed: "固定費用",
  redeems: "兌換",
  company_count_short: "0 間 | 1 間 | {count} 間",

  monitor_sequence_summary_step_count: "0 個步驟 | 1 個步驟 | {count} 個步驟",
  monitor_sequence_summary_contact_count:
    "0 位聯絡人 | 1 位聯絡人 | {count} 位聯絡人",
  search_sequence: "搜尋工作流程",
  create_new_sequence: "建立新工作流程",
  draft: "草稿",

  monitors_create_delivery_sequence_who_enrolled_title: "誰會被加入",
  monitors_create_delivery_sequence_edit_in_enrichment: "在資料增補中編輯",
  monitors_create_delivery_sequence_who_enrolled_tip:
    "來源在資料增補中設定。勾選或取消以控制工作流程加入 — 條件在資料增補中設定，而非在此。",
  monitor_create_delivery_sequence_company_contact: "公司聯絡人",
  monitor_create_delivery_sequence_company_contact_desc:
    "最佳匹配檔案 · 來自公司檔案",
  enrolling: "加入中",
  not_enrolling: "不加入",
  monitor_sequence_who_enrolled_people_title: "人物 - 來自人物搜尋",

  monitor_create_delivery_sequence_enroll_behavior_title: "加入行為",
  monitor_create_delivery_sequence_enroll_behavior_desc:
    "定義每種聯絡人情境下的處理方式。所有規則適用於每個已加入的來源。",

  monitor_create_delivery_sequence_enroll_behavior_new_contact_title:
    "新聯絡人",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_desc:
    "尚未加入此工作流程",
  start_at: "從步驟開始",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_placeholder:
    "例如：步驟 1 或步驟 2",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_title:
    "已在目標工作流程中",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_desc:
    "正在使用此監察器所用的相同工作流程",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_placeholder:
    "例如：從步驟 1 重新開始",
  skip: "略過",
  people_search: "人物搜尋",
  no_config_in_enrichment: "未在資料增補中設定",
  fetch_sequence_steps_failed: "無法取得工作流程步驟",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_option:
    "步驟 {index} - {step}",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_option:
    "從步驟 {index} - {step} 重新開始",

  // 繁體中文
  monitors_matched_deliver_signal_title: "公司與訊號",
  monitors_matched_deliver_signal_desc: "公司名稱，以及觸發此命中的訊號",
  monitors_matched_deliver_people_search_desc:
    "在電郵中列出姓名、職稱與聯絡資料",
  monitors_matched_deliver_title: "每筆命中將提供",
  to_somewhere: "至 {destination}",
  monitor_create_delivery_sequence_people_contact: "人員聯絡人",
  monitor_create_delivery_sequence_people_contact_desc:
    "來自所有啟用的人員搜尋區塊",
  selected_sequence_not_exist: "所選工作流程不存在",
  monitors_create_delivery_sequence_enrichment_invalid:
    "請新增人員聯絡人、公司聯絡人或兩者。",
  monitors_create_delivery_sequence_required: "請選擇一個工作流程以繼續。",
  failing: "失敗",
  monitor_create_delivery_sequence_warning_title: "未知工作流程",
  monitor_create_delivery_sequence_warning_desc:
    "工作流程已刪除 — 請選擇替代項目",
  deleted: "已刪除",
  owner: "創建者",
  not_triggered_yet: "尚未觸發",
};

export const monitors_zhCn = {
  off_company_enrichment_desc: "关闭 —— 匹配结果仅包含公司名称与信号",
  add_company_details: "添加公司详情",
  off_people_search_desc: "关闭 —— 不在匹配的公司中查找联系人",
  add_people_search: "添加人物搜索",
  monitor_flow_sequence_deleted_title:
    "指派的序列已被<span>删除</span>，因此此监控器没有投递目的地。它已被设为<span>停用</span>，在你连接新的目的地前将不会投递匹配的记录。",
  monitor_create_delivery_sequence_warning_assign_button: "指派新的目的地",
  // data export
  monitors_download_data_include: "包含",
  monitors_download_data_records: "{0} 条记录",
  monitors_download_data_layout: "格式",
  monitors_download_data_layout_one_sheet: "单一表格",
  monitors_download_data_layout_one_sheet_desc: "每家公司一行，人物合并",
  monitors_download_data_layout_separate: "分开文件",
  monitors_download_data_layout_separate_desc: "每类一个文件（.zip）",
  monitors_download_data_summary: "约 {0} 行 · CSV",
  monitors_download_data_truncated: "已达导出上限 — 请缩小范围",
  monitors_export_logs_title: "触发记录",
  monitors_export_logs_desc: "状态、积分及原始内容",
  monitors_export_data_title: "信号数据",
  monitors_export_data_desc: "公司、人物及信号",
  monitors_download_data_title: "下载数据",
  monitors_download_data_desc:
    "导出每次触发背后的信号、公司和人物——即您的目的地所接收的数据。",
  monitors_download_data_type: "数据类型",
  monitors_download_data_type_companies: "公司",
  monitors_download_data_type_signals: "信号",
  monitors_download_data_type_people: "人物",
  monitors_download_data_scope: "范围",
  monitors_download_data_scope_selected: "已选触发 ({0})",
  monitors_download_data_scope_range: "日期范围",
  monitors_download_data_range_start: "开始日期",
  monitors_download_data_range_end: "结束日期",
  monitors_download_data_people_hint:
    "仅当此监测启用人物增强时，才会显示人物数据。",
  monitors_download_data_confirm: "下载 CSV",
  // list
  monitors_list_item_statistic_tiggers_today: "今日触发次数",
  monitors_list_item_statistic_tiggers_today_desc: "较昨日 {0}%",
  monitors_list_item_statistic_last_trigger: "最近触发",
  monitors_list_item_statistic_today_trigger_count: "今日",
  monitors_list_item_statistic_success_rate: "成功率",
  avg_per_day: "日均",
  last_7_days: "最近 7 天",
  success_rate: "成功率",
  monitors_list_aside_skeleton_content:
    "创建你的第一个监控器，开始追踪信号，并在条件命中时收到通知。",

  //   create
  save_draft_and_exit: "保存草稿并退出",
  monitors_draft_system_name: "{subject} — 草稿 · {date}",
  back_to_monitors: "返回监控器列表",
  monitors_create_title: "设置监控器",
  monitors_create_header_desc: "在步骤 4（预览）为此监控器命名",
  monitors_edit_header_desc: "在步骤 4（预览）重命名此监控器",
  new_monitor: "新建监控器",
  monitors_create_flow_title: "监控流程",
  monitors_create_step_trigger: "触发条件",
  monitors_create_step_enrichment: "数据增强",
  monitors_create_step_delivery: "投递方式",
  monitors_create_step_preview: "预览",
  monitor_create_bottom_desc:
    "步骤 <span class='monitors-container-create-bottom-desc-heavy'>{step}</span>／共 {step_total} 步 · <span class='monitors-container-create-bottom-desc-heavy'>{step_name}</span> {step_desc}",

  monitors_create_step_trigger_desc: "选择要关注的内容。",
  monitors_create_step_enrichment_desc: "可选择添加公司信息或联系人。",
  monitors_create_step_delivery_desc: "选择匹配结果的发送位置。",
  monitors_create_step_preview_desc: "检查所有设置，然后创建。",

  //  create trigger
  monitors_create_signal_trigger_header_title: "信号触发",
  monitors_create_signal_trigger_header_desc:
    "信号是公司发生的事件。此触发条件决定什么会启动您的监控器。",

  monitors_create_signal_trigger_detection_mode_title: "检测模式",
  monitors_create_signal_trigger_detection_mode_desc: " —— 您想从什么开始？",
  signal_first: "信号优先",
  monitors_create_signal_trigger_detection_mode_signal_first_title:
    "某类型的事件",
  monitors_create_signal_trigger_detection_mode_signal_first_desc:
    "监控任何符合你筛选条件的公司，关注新闻、招聘或扩张等动态。",
  monitors_create_signal_trigger_detection_mode_signal_first_eg:
    "例如：<span>任何在 MY 招聘 Sales 的公司，或任何在 APAC 投放广告且规模 > 100 的公司</span>",
  company_first: "公司优先",
  monitors_create_signal_trigger_detection_mode_company_first_title:
    "我已知的特定公司",
  monitors_create_signal_trigger_detection_mode_company_first_desc:
    "选择你已关注的公司，当任何信号触发时收到提醒。",
  monitors_create_signal_trigger_detection_mode_company_first_eg:
    "例如：<span>监控 Amazon 和 Google 在新区域的 News，或香港的 Jobs</span>",
  monitors_create_signal_trigger_signal_types_label: "信号类型",
  monitors_create_signal_trigger_signal_types_label_addition: " —— 哪些事件？",
  monitors_create_signal_trigger_signal_types_tips:
    "每个信号都会独立触发。只要其中任意一个命中，你就会收到通知，不需要同时发生。",

  monitor_create_signal_breakdown: "<span>缩小范围</span>  · 可选",
  monitor_create_signal_breakdown_desc:
    "可选 —— 添加筛选条件，获得更少但更精准的匹配。",

  condition_count: "0 个条件 | 1 个条件 | {count} 个条件",

  monitors_create_signal_trigger_company_filter_title: "哪些公司符合条件",
  monitors_create_signal_trigger_company_filter_tag: "适用于所有信号",
  monitors_create_signal_trigger_company_filter_desc:
    "公司属性，例如规模、行业、总部所在国家或技术栈。",

  monitors_create_signal_trigger_company_monitor_title: "监控公司",
  monitors_create_signal_trigger_company_monitor_placeholder: "添加多个公司…",
  add_filter_condition: "添加筛选条件",
  monitors_create_signal_trigger_company_filter_label: "公司条件",
  monitors_create_signal_trigger_company_filter_label_addition:
    " —— 适用于哪些公司？",
  monitors_create_signal_trigger_signal_filter_label: "信号条件",
  monitors_create_signal_trigger_signal_filter_label_addition:
    " —— 有任何特定事件细节吗？",
  monitors_create_signal_trigger_max_record_title: "每次触发的最大记录数",
  monitors_create_signal_trigger_max_record_desc:
    "限制每次触发可处理的匹配公司数量。数据增强和人物搜索会对每条记录执行，此上限可避免在广泛信号场景下产生意外积分消耗。",

  tabNews_desc: "公司出现在新闻中",
  tabJobPostings_desc: "公司正在招聘",
  ads_desc: "公司开始投放广告",
  expansions_desc: "公司正在成长或扩张",

  monitors_create_signal_trigger_max_record_tips: "在第 1 步设置，可返回修改",
  monitors_create_signal_trigger_detection_mode_warning_1: "全局筛选已清空",
  monitors_create_signal_trigger_detection_mode_warning_2: "最近匹配已重置",
  monitors_create_signal_trigger_detection_mode_warning_3:
    "Webhook payload 已变更",
  monitors_create_signal_trigger_detection_mode_switch_to_signal_first:
    "切换为信号优先",
  monitors_create_signal_trigger_detection_mode_switch_to_company_first:
    "切换为公司优先",
  //   create enrichment
  monitors_create_enrichment_header_title: "数据增强与校验",
  monitors_create_enrichment_header_desc:
    "可在投递前增强信号数据，或通过 AI 条件进行校验",
  monitors_create_enrichment_company_details_title: "公司详情",
  monitors_create_enrichment_company_details_cost:
    "每次查询 0 积分 | 每次查询 1 积分 | 每次查询 {count} 积分",

  monitors_matched_deliver_company_detail_desc:
    "在 {destination} 中以完整公司资料显示",

  monitors_create_enrichment_company_details_desc:
    "为每条命中的信号补充规模、行业、总部和公司简介",
  monitors_create_enrichment_company_details_tips:
    "<span>最适合</span>用于按公司契合度进行筛选或分流。如果你已经知道目标公司，可<span>关闭</span>。",

  monitors_create_enrichment_people_search_title: "人物搜索",

  monitors_create_enrichment_people_search_cost:
    "每次搜索 0 积分 | 每次搜索 1 积分 | 每次搜索 {count} 积分",
  monitors_create_enrichment_people_search_desc:
    "可针对每条信号运行一个或多个人物搜索，每个搜索拥有独立筛选条件，结果会按组输出。",
  monitors_create_enrichment_people_search_tips:
    "<span>最适合</span>用于想自动展开的触达活动。如果你只需知道哪些公司有动态，可<span>关闭</span>。",
  monitors_create_enrichment_people_search_config_item_max_people_to_return:
    "最多返回人数",

  monitors_create_enrichment_people_search_config_item_redeem_contact_info:
    "兑换联系信息",
  monitors_create_enrichment_people_search_config_item_redeem_credits:
    "每人 0 积分 | 每人 1 积分 | 每人 {count} 积分",
  monitors_create_enrichment_people_search_config_add_one: "再添加一个人物搜索",
  monitors_create_enrichment_people_search_config_tips:
    "每个搜索都会独立执行。搜索费用按每次搜索计费，邮箱和电话兑换则按每位返回联系人单独计费。",
  monitors_create_enrichment_people_search_config_item_advanced_title:
    "<span>高级筛选</span>  · 可选",
  monitors_create_enrichment_people_search_config_item_advanced_desc:
    "筛选出已在名单或序列中的人物",
  monitors_create_enrichment_people_search_config_item_advanced_tips:
    "只返回<span>已经</span>在名单或序列中的人物。留空则搜索所有人，适合用于再次触达。",
  monitors_create_enrichment_people_search_config_item_advanced_label_saved_list:
    "已在保存的名单中",
  monitors_create_enrichment_people_search_config_item_advanced_label_sequence:
    "已在序列中",

  // create-delivery
  destination_type: "目标类型",
  monitors_create_delivery_title: "目标与投递",
  monitors_create_delivery_desc: "定义信号发送到哪里，以及发送频率",
  monitors_create_delivery_type_next_release: "v2.0",
  webhook: "Webhook",
  monitors_create_delivery_type_webhook_desc:
    "将信号数据推送到你的系统或第三方工具",
  monitors_create_delivery_type_email_title: "Email",
  monitors_create_delivery_type_email_desc: "通过邮件接收可读的信号摘要",
  monitors_create_delivery_type_sequences_title: "Sequences",
  monitors_create_delivery_type_sequences_desc:
    "自动将匹配联系人加入触达工作流程",
  monitors_create_delivery_type_sheets_title: "Sheets",
  monitors_create_delivery_type_sheets_desc:
    "将命中的信号同步到你偏好的数据目标",

  monitors_create_delivery_configuration_webhook: "Webhook 配置",
  monitors_create_delivery_configuration_email: "Email 配置",
  monitors_create_delivery_configuration_sequences: "Sequences 配置",
  monitors_create_delivery_configuration_sheets: "Sheets 配置",

  monitors_create_delivery_email_send_to_label: "发送到",
  monitors_create_delivery_email_send_to_placeholder: "johndoe@example.com",
  monitors_create_delivery_configuration_webhook_endpoint_url: "Endpoint URL",
  monitors_create_delivery_configuration_webhook_endpoint_url_placeholder:
    "https://your-webhook.site",
  monitors_create_delivery_headers: "Headers",
  optional: "可选",
  monitors_create_delivery_add_headers: "添加 Header",
  monitors_create_delivery_body: "Body 参数",
  monitors_create_delivery_add_body: "添加参数",
  monitors_create_key: "键",
  monitors_create_value: "值",
  monitors_create_delivery_alert_message_label: "失败告警邮箱",
  monitors_create_delivery_alert_message_placeholder: "当端点失败时通知该地址",
  monitors_create_delivery_run_test_webhook_title: "校验端点",
  monitors_create_delivery_run_test_webhook_desc:
    "发送测试 payload，确认你的服务器已正确接收",
  monitors_create_delivery_run_test_email_title: "校验邮箱",
  monitors_create_delivery_run_test_email_desc:
    "发送测试邮件，确认你的地址可正常收信",
  monitors_create_delivery_run_test_button: "发送测试",

  monitors_create_header_key_placeholder: "例如 Authorization",
  monitors_create_header_value_placeholder: "例如 Bearer your token",

  //   create preview
  monitors_create_preview_title: "检查并创建",
  monitors_create_preview_desc: "上线前确认你的配置",
  monitors_create_preview_define_name_title: "监控器名称 ",
  monitors_create_preview_define_name_placeholder:
    "例如：Hiring - Sales in MY（foreign cos, 100+）",
  monitors_create_preview_tips:
    "你的 API Key（X-Pubrio-Signature）会在创建后生成，并立即显示在 Settings 标签页。",

  monitors_create_preview_summary:
    "此监控器会监控 <span>{companies}</span> 的 <span>{signals}</span>，并将匹配结果发送至 <span>{destination}</span>，以 {interval} 检查。",
  any_matching_companies: "任何匹配的公司",

  // detail settings
  monitor: "监控器",
  monitors: "监控器",
  delivery: "投递",
  sync_interval: "同步频率",
  sync_interval_description: "检查新信号的频率",
  alert_email: "告警邮箱",
  alert_email_description:
    "当发生任何失败，或此监控器被自动暂停时，我们会向你发送邮件通知",

  failure_handle: "失败处理",
  failure_handle_retry_attempts: "重试次数",
  failure_handle_retry_attempts_desc: "在将投递标记为失败前，最多重试多少次",
  failure_handle_retry_delay: "重试延迟",
  failure_handle_retry_delay_desc: "每次重试之间等待多久",
  failure_handle_auto_pause_failures_count: "连续失败后自动暂停",
  failure_handle_auto_pause_failures_count_desc:
    "Pubrio 会自动停用此监控器，以避免积分浪费。你也会收到失败告警邮件",
  failure_handle_daily_trigger_cap: "每日触发上限",
  failure_handle_daily_trigger_cap_desc:
    "每天最多触发次数，用于控制积分消耗。0 = 不限",
  security: "安全",
  monitors_list_detail_settings_security_api_key_title:
    "API Key（X-Pubrio-Signature）",
  monitors_list_detail_settings_security_api_key_description:
    "将其接入你的服务端校验逻辑",
  copied: "已复制",

  //   detail tabs
  monitors_detail_tab_flow: "流程",

  // wizard
  getting_started: "开始使用",
  monitors_wizard_introduction_title: "追踪信号，自动路由匹配结果",
  monitors_wizard_introduction_desc:
    "监控器会持续关注您关心的信号——招聘、新闻、广告、融资——然后为每条匹配结果补充信息，并发送到您工作的任何地方。三步即可完成设置。",
  // Wizard guided tour (driver.js)
  monitor_wizard_tour_step_1_title: "欢迎——一起捕捉购买信号",
  monitor_wizard_tour_step_1_desc:
    "监控器会持续关注企业的招聘、融资等信号，一旦有匹配项就立即通知您。让我们创建您的第一个监控器。",
  monitor_wizard_tour_step_2_title: "先决定要关注什么",
  monitor_wizard_tour_step_2_desc:
    "挑选您关心的信号：招聘、新闻、广告和扩张。只要其中任何一项触发，我们就会通知您。",
  monitor_wizard_tour_step_3_title: "看着它逐渐成形",
  monitor_wizard_tour_step_3_desc:
    "这个实时预览会以流程图呈现您的监控器，包括触发条件、我们补充的数据，以及发送的去向。",
  monitor_wizard_tour_step_4_title: "加上您用得到的细节",
  monitor_wizard_tour_step_4_desc:
    "开启公司信息或真实联系人，让每条匹配结果不只是名称，而是可立即行动。",
  monitor_wizard_tour_step_5_title: "把匹配结果发送到您工作的地方",
  monitor_wizard_tour_step_5_desc:
    "电子邮件、序列、电子表格或您自己的工具。选择您想要处理这些匹配结果的位置。",
  monitor_wizard_tour_step_6_title: "清楚看见您会得到什么",
  monitor_wizard_tour_step_6_desc:
    "这个面板会随时显示每条匹配结果提供的内容，让您在完成前就了解其价值。",
  monitor_wizard_tour_step_7_title: "准备就绪！立即创建！",
  monitor_wizard_tour_step_7_desc:
    "走完最后一个画面并点击“创建”。您的监控器即会上线，开始捕捉信号。",
  monitors_wizard_tips: "约 2 分钟即可完成设置",
  create_first_monitor: "创建第一个监控器",

  monitors_trigger_types_str: "职位发布 · 新闻 · 广告",
  custom_interval: "自定义频率",
  monitors_wizard_define_trigger_title: "定义触发条件",
  monitors_wizard_define_trigger_desc:
    "选择要监控的信号并设置筛选条件以缩小匹配范围。你可以追踪任意公司，或指定一组公司。",
  monitors_wizard_enrich_signal_data_title: "增强信号数据",
  monitors_wizard_enrich_signal_data_desc:
    "可选附加公司详情，或运行人物搜索，找出命中公司的目标联系人。",
  monitors_wizard_choose_destination_title: "选择目标",
  monitors_wizard_choose_destination_desc:
    "将匹配信号数据发送到 webhook、email 或已连接工具，并设置同步频率，从实时到每天都可以。",
  monitors_wizard_example_title: "监控器示例",

  presets: "预设",

  // flow
  monitors_flow_company_enrichment: "公司数据增强",
  destination: "目标",
  add_filter: "添加筛选",
  field: "字段",
  operator: "操作符",
  real_time: "实时",

  monitors_create_company_first_one_company_at_least:
    "请至少添加一家需要监控的公司。",
  monitors_create_signal_types_one_at_least: "请至少选择一种信号类型后再继续。",
  monitors_create_validation_signal_types_required:
    "请至少选择一种要监控的信号类型。",
  monitors_create_validation_email_required: "请添加至少一个收件人电子邮箱地址。",
  monitors_create_validation_name_required: "请为监控器命名，方便日后查找。",

  credits_cost: "0 积分 | 1 积分 | {count} 积分",

  // try
  monitor_try_popover_title: "试运行此监控器",
  monitor_try_popover_desc: "选择要回溯运行的日期。如命中结果，将消耗积分。",
  monitor_try_popover_form_date_label: "日期",
  monitor_try_popover_max_results_label: "最大结果数",
  run_query: "运行查询",
  monitors_try_button: "运行测试查询",

  // list aside filters
  last_trigger_at_descending: "最近触发（最新优先）",
  last_trigger_at_ascending: "最近触发（最早优先）",
  name_ascending: "名称（A-Z）",
  name_descending: "名称（Z-A）",

  // signals
  news: "新闻",
  jobs: "职位发布",
  signal_types: "信号类型",
  news_filter: "News 筛选",
  jobs_filter: "Jobs 筛选",
  advertisements_filter: "Advertisements 筛选",
  global_filters: "全局筛选",

  company_enrichment_enable_desc: "已添加规模、行业、总部和公司简介",
  company_enrichment_enable_fields: "规模、行业、总部、公司简介",
  off: "关闭",

  max_people_count: "最多 0 人 | 最多 1 人 | 最多 {count} 人",
  "monitor_detail_logs-table-empty-title": "暂无日志",
  "monitor_detail_logs-table-empty-desc":
    "此监控器开始接收信号后，日志会显示在这里。可以先运行一次测试查询来触发首个事件。",

  signal: "信号",
  detection: "检测",
  monitor_detail_logs_payload_sent: "已发送 payload",
  monitor_detail_logs_payload_received: "响应",
  monitor_detail_logs_trigger_config: "触发配置",

  create_monitor: "创建监控器",
  update_monitor: "更新监控器",

  monitors_edit_title: "编辑监控器",
  global: "全局",
  navMonitorsDesc: "追踪公司，并在出现适合联系的时机时收到通知。",

  trigger_limits: "触发限制",
  monitor_not_found: "未找到监控器",
  please_select_field_and_operator_first: "请先选择字段和操作符",

  people_count: "0 位联系人 | 1 位联系人 | {count} 位联系人",
  search_fee: "搜索费用 {0} 积分",
  email_cost: "邮箱兑换费用 {0} 积分",
  phone_cost: "电话兑换费用 {0} 积分",
  estimated_cost: "预估成本:",
  monitors_create_enrichment_people_search_config_item_credits_message:
    "预估成本: 最低 <strong>{0}</strong>，最高 <strong>{1}</strong> = {2}",

  monitor_estimate_cost_title: "每次触发预估成本",
  monitor_estimate_cost_max_record:
    "最多 0 条记录 | 最多 1 条记录 | 最多 {count} 条记录",
  credits_cost_range: "{0} 积分",
  signal_detection: "信号检测",
  matched_companies: "0 家匹配公司 | 1 家匹配公司 | {count} 家匹配公司",
  min_prefix: "最低: ",
  max_prefix: "最高: ",

  recovered: "已恢复",
  breakdown: "费用明细",
  monitor_estimate_cost_fixed_per_trigger: "每次触发固定费用",
  credits_cost_short: "0 积分 | 1 积分 | {count} 积分",
  credits_cost_short_per_company: "0 积分/家 | 1 积分/家 | {count} 积分/家",
  monitor_estimate_cost_per_match_company: "每家匹配公司",
  monitor_estimate_cost_per_company_subtotal: "每家公司小计",
  monitor_estimate_cost_redeem_cost: "每家匹配公司兑换费用",
  monitor_estimate_cost_redeem_subtotal: "兑换小计",
  monitor_estimate_cost_redeem_list_name: "PS{0} {1} × {2} 人",
  monitor_estimate_cost_fixed_desc:
    "信号检测为固定费用，每次触发计费一次，与命中公司数量无关。",
  monitor_estimate_cost_fixed: "固定费用",
  redeems: "兑换",
  company_count_short: "0 家 | 1 家 | {count} 家",

  monitor_sequence_summary_step_count: "0 个步骤 | 1 个步骤 | {count} 个步骤",
  monitor_sequence_summary_contact_count:
    "0 位联系人 | 1 位联系人 | {count} 位联系人",
  search_sequence: "搜索工作流程",
  create_new_sequence: "创建新工作流程",
  draft: "草稿",

  monitors_create_delivery_sequence_who_enrolled_title: "谁会被加入",
  monitors_create_delivery_sequence_edit_in_enrichment: "在数据增强中编辑",
  monitors_create_delivery_sequence_who_enrolled_tip:
    "来源在数据增强中配置。勾选或取消以控制工作流程加入 — 条件在数据增强中设置，不在这里。",
  monitor_create_delivery_sequence_company_contact: "公司联系人",
  monitor_create_delivery_sequence_company_contact_desc:
    "最佳匹配档案 · 来自公司档案",
  enrolling: "加入中",
  not_enrolling: "不加入",
  monitor_sequence_who_enrolled_people_title: "人物 - 来自人物搜索",

  monitor_create_delivery_sequence_enroll_behavior_title: "加入行为",
  monitor_create_delivery_sequence_enroll_behavior_desc:
    "定义每种联系人情境下的处理方式。所有规则适用于每个已加入的来源。",

  monitor_create_delivery_sequence_enroll_behavior_new_contact_title:
    "新联系人",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_desc:
    "尚未加入此工作流程",
  start_at: "从步骤开始",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_placeholder:
    "例如：步骤 1 或步骤 2",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_title:
    "已在目标工作流程中",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_desc:
    "正在使用此监控器所用的相同工作流程",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_placeholder:
    "例如：从步骤 1 重新开始",
  skip: "跳过",
  people_search: "人物搜索",
  no_config_in_enrichment: "未在数据增强中配置",
  fetch_sequence_steps_failed: "无法获取工作流程步骤",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_option:
    "步骤 {index} - {step}",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_option:
    "从步骤 {index} - {step} 重新开始",

  // 简体中文
  monitors_matched_deliver_signal_title: "公司与信号",
  monitors_matched_deliver_signal_desc: "公司名称，以及触发此匹配的信号",
  monitors_matched_deliver_people_search_desc:
    "在邮件中列出姓名、职位与联系方式",
  monitors_matched_deliver_title: "每条匹配将提供",
  to_somewhere: "至 {destination}",
  monitor_create_delivery_sequence_people_contact: "人员联系人",
  monitor_create_delivery_sequence_people_contact_desc:
    "来自所有激活的人物搜索模块",
  selected_sequence_not_exist: "所选工作流程不存在",
  monitors_create_delivery_sequence_enrichment_invalid:
    "请添加人员联系人、公司联系人或两者。",
  monitors_create_delivery_sequence_required: "请选择一个工作流程以继续。",
  failing: "失败",
  monitor_create_delivery_sequence_warning_title: "未知工作流程",
  monitor_create_delivery_sequence_warning_desc:
    "工作流程已删除 — 请选择替换项",
  deleted: "已删除",
  owner: "创建者",
  not_triggered_yet: "尚未触发",
};

export const monitors_hi = {
  off_company_enrichment_desc: "बंद — मैच में केवल कंपनी का नाम और सिग्नल शामिल हैं",
  add_company_details: "कंपनी विवरण जोड़ें",
  off_people_search_desc: "बंद — मेल खाती कंपनियों में संपर्क नहीं खोजे जा रहे",
  add_people_search: "व्यक्ति खोज जोड़ें",
  monitor_flow_sequence_deleted_title:
    "असाइन किया गया सीक्वेंस <span>हटा दिया गया</span> था, इसलिए इस मॉनिटर का कोई गंतव्य नहीं है। इसे <span>निष्क्रिय</span> कर दिया गया है और जब तक आप नया गंतव्य नहीं जोड़ते, यह मेल खाते रिकॉर्ड डिलीवर नहीं करेगा।",
  monitor_create_delivery_sequence_warning_assign_button:
    "नया गंतव्य असाइन करें",
  // data export
  monitors_download_data_include: "शामिल करें",
  monitors_download_data_records: "{0} रिकॉर्ड",
  monitors_download_data_layout: "लेआउट",
  monitors_download_data_layout_one_sheet: "एक शीट",
  monitors_download_data_layout_one_sheet_desc:
    "प्रति कंपनी एक पंक्ति, लोग संयुक्त",
  monitors_download_data_layout_separate: "अलग फ़ाइलें",
  monitors_download_data_layout_separate_desc: "प्रति प्रकार एक फ़ाइल (.zip)",
  monitors_download_data_summary: "≈ {0} पंक्तियाँ · CSV",
  monitors_download_data_truncated: "निर्यात सीमा पूरी — दायरा घटाएँ",
  monitors_export_logs_title: "ट्रिगर लॉग",
  monitors_export_logs_desc: "स्थिति, क्रेडिट और रॉ पेलोड",
  monitors_export_data_title: "सिग्नल डेटा",
  monitors_export_data_desc: "कंपनियाँ, लोग और सिग्नल",
  monitors_download_data_title: "डेटा डाउनलोड करें",
  monitors_download_data_desc:
    "प्रत्येक ट्रिगर के पीछे के सिग्नल, कंपनियाँ और लोग निर्यात करें — वही डेटा जो आपके गंतव्य को मिलता है।",
  monitors_download_data_type: "डेटा प्रकार",
  monitors_download_data_type_companies: "कंपनियाँ",
  monitors_download_data_type_signals: "सिग्नल",
  monitors_download_data_type_people: "लोग",
  monitors_download_data_scope: "दायरा",
  monitors_download_data_scope_selected: "चयनित ट्रिगर ({0})",
  monitors_download_data_scope_range: "तिथि सीमा",
  monitors_download_data_range_start: "प्रारंभ तिथि",
  monitors_download_data_range_end: "समाप्ति तिथि",
  monitors_download_data_people_hint:
    "लोगों की पंक्तियाँ तभी दिखती हैं जब यह मॉनिटर लोगों को समृद्ध करता है।",
  monitors_download_data_confirm: "CSV डाउनलोड करें",
  // list
  monitors_list_item_statistic_tiggers_today: "आज के ट्रिगर",
  monitors_list_item_statistic_tiggers_today_desc: "कल की तुलना में {0}%",
  monitors_list_item_statistic_last_trigger: "आखिरी ट्रिगर",
  monitors_list_item_statistic_today_trigger_count: "आज",
  monitors_list_item_statistic_success_rate: "सफलता दर",
  avg_per_day: "औसत प्रति दिन",
  last_7_days: "पिछले 7 दिन",
  success_rate: "सफलता दर",
  monitors_list_aside_skeleton_content:
    "अपना पहला मॉनिटर बनाइए, सिग्नल ट्रैक कीजिए और मेल खाने पर सूचना पाइए।",

  //   create
  save_draft_and_exit: "ड्राफ्ट सहेजें और बाहर निकलें",
  monitors_draft_system_name: "{subject} — ड्राफ़्ट · {date}",
  back_to_monitors: "मॉनिटर सूची पर वापस जाएँ",
  monitors_create_title: "मॉनिटर सेट करें",
  monitors_create_header_desc: "इस मॉनिटर को चरण 4 (प्रीव्यू) में नाम दें",
  monitors_edit_header_desc: "इस मॉनिटर का नाम चरण 4 (प्रीव्यू) में बदलें",
  new_monitor: "नया मॉनिटर",
  monitors_create_flow_title: "मॉनिटर प्रवाह",
  monitors_create_step_trigger: "ट्रिगर",
  monitors_create_step_enrichment: "समृद्धि",
  monitors_create_step_delivery: "डिलीवरी",
  monitors_create_step_preview: "पूर्वावलोकन",
  monitor_create_bottom_desc:
    "चरण <span class='monitors-container-create-bottom-desc-heavy'>{step}</span> / {step_total} ·  <span class='monitors-container-create-bottom-desc-heavy'>{step_name}</span> {step_desc}",

  monitors_create_step_trigger_desc: "चुनें कि किस पर नज़र रखनी है।",
  monitors_create_step_enrichment_desc:
    "वैकल्पिक रूप से कंपनी की जानकारी या संपर्क जोड़ें।",
  monitors_create_step_delivery_desc: "चुनें कि मैच कहाँ भेजे जाएँ।",
  monitors_create_step_preview_desc: "सब कुछ जाँचें, फिर बनाएँ।",

  //  create trigger
  monitors_create_signal_trigger_header_title: "सिग्नल ट्रिगर",
  monitors_create_signal_trigger_header_desc:
    "सिग्नल किसी कंपनी में घटित एक घटना है। यह ट्रिगर तय करता है कि आपका मॉनिटर किससे शुरू होता है।",

  monitors_create_signal_trigger_detection_mode_title: "पहचान मोड",
  monitors_create_signal_trigger_detection_mode_desc:
    " — आप किससे शुरू करना चाहते हैं?",
  signal_first: "सिग्नल पहले",
  monitors_create_signal_trigger_detection_mode_signal_first_title:
    "एक प्रकार की घटना",
  monitors_create_signal_trigger_detection_mode_signal_first_desc:
    "अपने फ़िल्टर से मेल खाती किसी भी कंपनी में समाचार, भर्ती या विस्तार जैसी गतिविधियों पर नज़र रखें।",
  monitors_create_signal_trigger_detection_mode_signal_first_eg:
    "जैसे: <span>MY में Sales के लिए भर्ती कर रही कोई भी कंपनी, या APAC में विज्ञापन चला रही और आकार > 100 वाली कोई भी कंपनी</span>",
  company_first: "कंपनी पहले",
  monitors_create_signal_trigger_detection_mode_company_first_title:
    "मेरी जानी-पहचानी विशिष्ट कंपनियाँ",
  monitors_create_signal_trigger_detection_mode_company_first_desc:
    "उन कंपनियों को चुनें जिनमें आपकी पहले से रुचि है, और उनके लिए कोई सिग्नल सक्रिय होने पर अलर्ट पाएँ।",
  monitors_create_signal_trigger_detection_mode_company_first_eg:
    "जैसे: <span>Amazon और Google के लिए नए क्षेत्रों की खबरें, या Hong Kong में भर्ती संकेत मॉनिटर करें</span>",
  monitors_create_signal_trigger_signal_types_label: "सिग्नल प्रकार",
  monitors_create_signal_trigger_signal_types_label_addition:
    " — कौन-सी घटनाएँ?",
  monitors_create_signal_trigger_signal_types_tips:
    "हर सिग्नल स्वतंत्र रूप से सक्रिय होता है। इनमें से कोई भी एक मेल खाते ही आपको सूचना मिलेगी; इन्हें एक साथ होना जरूरी नहीं है।",

  monitor_create_signal_breakdown: "<span>इसे सीमित करें</span>  · वैकल्पिक",
  monitor_create_signal_breakdown_desc:
    "वैकल्पिक — कम लेकिन अधिक विशिष्ट मैच के लिए फ़िल्टर जोड़ें।",

  condition_count: "0 शर्तें | 1 शर्त | {count} शर्तें",

  monitors_create_signal_trigger_company_filter_title:
    "कौन-सी कंपनियाँ योग्य हैं",
  monitors_create_signal_trigger_company_filter_tag: "सभी सिग्नल पर लागू",
  monitors_create_signal_trigger_company_filter_desc:
    "कंपनी की विशेषताएँ जैसे आकार, उद्योग, मुख्यालय देश, या टेक स्टैक।",

  monitors_create_signal_trigger_company_monitor_title:
    "निगरानी में रखने वाली कंपनियाँ",
  monitors_create_signal_trigger_company_monitor_placeholder:
    "एक से अधिक कंपनियाँ जोड़ें...",
  add_filter_condition: "फ़िल्टर शर्त जोड़ें",
  monitors_create_signal_trigger_company_filter_label: "कंपनी मानदंड",
  monitors_create_signal_trigger_company_filter_label_addition:
    " — किन कंपनियों के लिए?",
  monitors_create_signal_trigger_signal_filter_label: "सिग्नल शर्तें",
  monitors_create_signal_trigger_signal_filter_label_addition:
    " — कोई विशिष्ट घटना विवरण?",
  monitors_create_signal_trigger_max_record_title:
    "प्रति ट्रिगर अधिकतम रिकॉर्ड",
  monitors_create_signal_trigger_max_record_desc:
    "हर ट्रिगर पर संसाधित होने वाली मेल खाती कंपनियों की संख्या सीमित करता है। समृद्धि और व्यक्ति खोज हर रिकॉर्ड पर चलती हैं, इसलिए यह सीमा व्यापक सिग्नल की स्थिति में अनपेक्षित क्रेडिट खर्च रोकती है।",

  tabNews_desc: "कोई कंपनी ख़बरों में है",
  tabJobPostings_desc: "कोई कंपनी भर्ती कर रही है",
  ads_desc: "कोई कंपनी विज्ञापन शुरू करती है",
  expansions_desc: "कोई कंपनी बढ़ रही है या विस्तार कर रही है",

  monitors_create_signal_trigger_max_record_tips:
    "इसे चरण 1 में सेट करें - बदलने के लिए वापस जाएँ",
  monitors_create_signal_trigger_detection_mode_warning_1:
    "वैश्विक फ़िल्टर साफ़ कर दिए गए",
  monitors_create_signal_trigger_detection_mode_warning_2:
    "हाल के मिलान रीसेट कर दिए गए",
  monitors_create_signal_trigger_detection_mode_warning_3:
    "Webhook पेलोड बदल गया है",
  monitors_create_signal_trigger_detection_mode_switch_to_signal_first:
    "सिग्नल पहले पर स्विच करें",
  monitors_create_signal_trigger_detection_mode_switch_to_company_first:
    "कंपनी पहले पर स्विच करें",
  //   create enrichment
  monitors_create_enrichment_header_title: "समृद्धि और सत्यापन",
  monitors_create_enrichment_header_desc:
    "डिलीवरी से पहले सिग्नल डेटा को समृद्ध करें या AI शर्तें लागू करें",
  monitors_create_enrichment_company_details_title: "कंपनी विवरण",
  monitors_create_enrichment_company_details_cost:
    "प्रति खोज 0 क्रेडिट | प्रति खोज 1 क्रेडिट | प्रति खोज {count} क्रेडिट",

  monitors_matched_deliver_company_detail_desc:
    "{destination} में पूर्ण कंपनी प्रोफ़ाइल के रूप में दिखाया जाता है",

  monitors_create_enrichment_company_details_desc:
    "हर मेल खाते सिग्नल में आकार, उद्योग, मुख्यालय और कंपनी प्रोफ़ाइल जोड़ें",
  monitors_create_enrichment_company_details_tips:
    "<span>सबसे उपयुक्त</span> कंपनी की उपयुक्तता के आधार पर योग्यता तय करने या रूटिंग के लिए। यदि आप कंपनियों को पहले से जानते हैं तो इसे <span>बंद रखें</span>।",

  monitors_create_enrichment_people_search_title: "व्यक्ति खोज",

  monitors_create_enrichment_people_search_cost:
    "प्रति खोज 0 क्रेडिट | प्रति खोज 1 क्रेडिट | प्रति खोज {count} क्रेडिट",
  monitors_create_enrichment_people_search_desc:
    "हर सिग्नल के लिए एक या अधिक व्यक्ति खोज चलाएँ, जिनके अपने फ़िल्टर हो सकते हैं। परिणाम आउटपुट में समूहबद्ध रहते हैं।",
  monitors_create_enrichment_people_search_tips:
    "<span>सबसे उपयुक्त</span> उस आउटरीच के लिए जिसे आप स्वतः शुरू करना चाहते हैं। यदि आपको केवल यह जानना है कि कौन-सी कंपनियाँ सक्रिय हैं, तो इसे <span>बंद रखें</span>।",
  monitors_create_enrichment_people_search_config_item_max_people_to_return:
    "लौटाए जाने वाले लोगों की अधिकतम संख्या",

  monitors_create_enrichment_people_search_config_item_redeem_contact_info:
    "संपर्क जानकारी रिडीम करें",
  monitors_create_enrichment_people_search_config_item_redeem_credits:
    "प्रति व्यक्ति 0 क्रेडिट | प्रति व्यक्ति 1 क्रेडिट | प्रति व्यक्ति {count} क्रेडिट",
  monitors_create_enrichment_people_search_config_add_one:
    "एक और व्यक्ति खोज जोड़ें",
  monitors_create_enrichment_people_search_config_tips:
    "हर खोज स्वतंत्र रूप से चलती है। खोज शुल्क प्रति खोज लगता है, जबकि ईमेल और फ़ोन रिडेम्प्शन प्रति लौटाए गए व्यक्ति अलग से लिया जाता है।",
  monitors_create_enrichment_people_search_config_item_advanced_title:
    "<span>उन्नत फ़िल्टर</span>  · वैकल्पिक",
  monitors_create_enrichment_people_search_config_item_advanced_desc:
    "उन लोगों तक सीमित करें जो पहले से किसी सूची या सीक्वेंस में हैं",
  monitors_create_enrichment_people_search_config_item_advanced_tips:
    "केवल उन लोगों को लौटाएं जो <span>पहले से</span> किसी सूची या सीक्वेंस में हैं। सभी को खोजने के लिए खाली छोड़ें। दोबारा जुड़ने के लिए उपयोगी।",
  monitors_create_enrichment_people_search_config_item_advanced_label_saved_list:
    "पहले से सहेजी गई सूची में",
  monitors_create_enrichment_people_search_config_item_advanced_label_sequence:
    "पहले से सीक्वेंस में",

  // create-delivery
  destination_type: "गंतव्य प्रकार",
  monitors_create_delivery_title: "गंतव्य और डिलीवरी",
  monitors_create_delivery_desc:
    "सिग्नल कहाँ भेजने हैं और कितनी बार भेजने हैं, यह तय करें",
  monitors_create_delivery_type_next_release: "v2.0",
  webhook: "Webhook",
  monitors_create_delivery_type_webhook_desc:
    "सिग्नल डेटा को अपने सिस्टम या बाहरी टूल में भेजें",
  monitors_create_delivery_type_email_title: "ईमेल",
  monitors_create_delivery_type_email_desc:
    "ईमेल के जरिए मेल खाते सिग्नल का पढ़ने योग्य सार पाएँ",
  monitors_create_delivery_type_sequences_title: "क्रम",
  monitors_create_delivery_type_sequences_desc:
    "मेल खाते संपर्कों को संपर्क क्रम में अपने आप शामिल करें",
  monitors_create_delivery_type_sheets_title: "शीट्स",
  monitors_create_delivery_type_sheets_desc:
    "मेल खाते सिग्नल को अपने पसंदीदा डेटा गंतव्य से समन्वयित करें",

  monitors_create_delivery_configuration_webhook: "Webhook विन्यास",
  monitors_create_delivery_configuration_email: "ईमेल विन्यास",
  monitors_create_delivery_configuration_sequences: "क्रम विन्यास",
  monitors_create_delivery_configuration_sheets: "शीट विन्यास",

  monitors_create_delivery_email_send_to_label: "भेजें",
  monitors_create_delivery_email_send_to_placeholder: "johndoe@example.com",
  monitors_create_delivery_configuration_webhook_endpoint_url: "एंडपॉइंट URL",
  monitors_create_delivery_configuration_webhook_endpoint_url_placeholder:
    "https://your-webhook.site",
  monitors_create_delivery_headers: "हेडर",
  optional: "वैकल्पिक",
  monitors_create_delivery_add_headers: "हेडर जोड़ें",
  monitors_create_delivery_body: "बॉडी पैरामीटर",
  monitors_create_delivery_add_body: "पैरामीटर जोड़ें",
  monitors_create_key: "कुंजी",
  monitors_create_value: "मान",
  monitors_create_delivery_alert_message_label: "विफलता सूचना ईमेल",
  monitors_create_delivery_alert_message_placeholder:
    "एंडपॉइंट विफल होने पर इस पते पर सूचना भेजें",
  monitors_create_delivery_run_test_webhook_title: "एंडपॉइंट सत्यापित करें",
  monitors_create_delivery_run_test_webhook_desc:
    "परीक्षण पेलोड भेजकर पुष्टि करें कि आपका सर्वर सही तरह प्राप्त कर रहा है",
  monitors_create_delivery_run_test_email_title: "ईमेल सत्यापित करें",
  monitors_create_delivery_run_test_email_desc:
    "परीक्षण ईमेल भेजकर पुष्टि करें कि आपका पता सही तरह प्राप्त कर रहा है",
  monitors_create_delivery_run_test_button: "परीक्षण भेजें",

  monitors_create_header_key_placeholder: "जैसे Authorization",
  monitors_create_header_value_placeholder: "जैसे Bearer your token",

  //   create preview
  monitors_create_preview_title: "समीक्षा करें और बनाएँ",
  monitors_create_preview_desc: "चालू करने से पहले अपनी सेटिंग की पुष्टि करें",
  monitors_create_preview_define_name_title: "मॉनिटर नाम ",
  monitors_create_preview_define_name_placeholder:
    "जैसे: मलेशिया में बिक्री भर्ती - विदेशी कंपनियाँ, 100+ कर्मचारी",
  monitors_create_preview_tips:
    "आपकी API कुंजी (X-Pubrio-Signature) बनाने के बाद तैयार होगी और तुरंत सेटिंग टैब में दिखाई जाएगी।",

  monitors_create_preview_summary:
    "यह मॉनिटर <span>{companies}</span> पर <span>{signals}</span> पर नज़र रखता है, फिर मैच को <span>{destination}</span> पर भेजता है, {interval} में जाँचा जाता है।",
  any_matching_companies: "कोई भी मेल खाती कंपनी",

  // detail settings
  monitor: "मॉनिटर",
  monitors: "मॉनिटर",
  delivery: "DELIVERY",
  sync_interval: "समन्वय अंतराल",
  sync_interval_description: "नए सिग्नल कितनी बार जाँचने हैं",
  alert_email: "सूचना ईमेल",
  alert_email_description:
    "किसी भी विफलता पर और जब यह मॉनिटर अपने आप रुकेगा, तब हम आपको ईमेल करेंगे",

  failure_handle: "विफलता प्रबंधन",
  failure_handle_retry_attempts: "पुनः प्रयासों की संख्या",
  failure_handle_retry_attempts_desc:
    "डिलीवरी को विफल चिह्नित करने से पहले कितनी बार पुनः प्रयास करना है",
  failure_handle_retry_delay: "पुनः प्रयास विलंब",
  failure_handle_retry_delay_desc: "हर पुनः प्रयास के बीच कितना इंतजार करना है",
  failure_handle_auto_pause_failures_count:
    "लगातार विफलताओं के बाद स्वतः विराम",
  failure_handle_auto_pause_failures_count_desc:
    "क्रेडिट की बर्बादी रोकने के लिए Pubrio इस मॉनिटर को अपने आप निष्क्रिय कर देगा। आपको विफलता सूचना ईमेल भी मिलेगा",
  failure_handle_daily_trigger_cap: "दैनिक ट्रिगर सीमा",
  failure_handle_daily_trigger_cap_desc:
    "प्रति दिन अधिकतम ट्रिगर - क्रेडिट खर्च को नियंत्रित करने में मदद करता है। 0 = असीमित",
  security: "सुरक्षा",
  monitors_list_detail_settings_security_api_key_title:
    "API कुंजी (X-Pubrio-Signature)",
  monitors_list_detail_settings_security_api_key_description:
    "इसे अपने सर्वर-पक्ष सत्यापन तर्क में जोड़ें",
  copied: "कॉपी हो गया",

  //   detail tabs
  monitors_detail_tab_flow: "प्रवाह",

  // wizard
  getting_started: "शुरुआत करें",
  monitors_wizard_introduction_title:
    "सिग्नल ट्रैक करें और मैच को अपने आप रूट करें",
  monitors_wizard_introduction_desc:
    "एक मॉनिटर आपके लिए ज़रूरी सिग्नल—हायरिंग, न्यूज़, विज्ञापन, फंडिंग—पर नज़र रखता है, फिर हर मैच को इनरिच करके उसे आपकी पसंदीदा जगह भेज देता है। तीन चरणों में सेटअप करें।",
  // Wizard guided tour (driver.js)
  monitor_wizard_tour_step_1_title: "स्वागत है — आइए खरीदारी के संकेत पकड़ें",
  monitor_wizard_tour_step_1_desc:
    "एक मॉनिटर कंपनियों पर हायरिंग या फंडिंग जैसे संकेतों के लिए नज़र रखता है, और जैसे ही कोई मैच होता है आपको तुरंत सूचित करता है। आइए आपका पहला मॉनिटर बनाएं।",
  monitor_wizard_tour_step_2_title: "पहले तय करें कि किस पर नज़र रखनी है",
  monitor_wizard_tour_step_2_desc:
    "वे संकेत चुनें जो मायने रखते हैं: हायरिंग, न्यूज़, विज्ञापन और विस्तार। इनमें से कोई भी सक्रिय होते ही हम आपको सूचित करेंगे।",
  monitor_wizard_tour_step_3_title: "इसे आकार लेते देखें",
  monitor_wizard_tour_step_3_desc:
    "यह लाइव प्रीव्यू आपके मॉनिटर को एक पाइपलाइन के रूप में दिखाता है — इसे क्या ट्रिगर करता है, हम क्या जोड़ते हैं, और यह कहाँ जाता है।",
  monitor_wizard_tour_step_4_title: "वह जानकारी जोड़ें जो आप उपयोग करेंगे",
  monitor_wizard_tour_step_4_desc:
    "कंपनी की जानकारी या वास्तविक संपर्क चालू करें ताकि हर मैच सिर्फ़ एक नाम नहीं, बल्कि कार्रवाई के लिए तैयार हो।",
  monitor_wizard_tour_step_5_title: "मैच वहाँ भेजें जहाँ आप काम करते हैं",
  monitor_wizard_tour_step_5_desc:
    "ईमेल, एक सीक्वेंस, एक स्प्रेडशीट, या आपके अपने टूल। चुनें कि आप मैच पर कहाँ कार्रवाई करना चाहते हैं।",
  monitor_wizard_tour_step_6_title: "देखें कि आपको वास्तव में क्या मिलेगा",
  monitor_wizard_tour_step_6_desc:
    "यह पैनल हमेशा दिखाता है कि हर मैच क्या देता है, ताकि आप पूरा करने से पहले ही उसका मूल्य जान सकें।",
  monitor_wizard_tour_step_7_title: "आप तैयार हैं! इसे बनाएं!",
  monitor_wizard_tour_step_7_desc:
    "आखिरी स्क्रीन से गुज़रें और Create दबाएं। आपका मॉनिटर लाइव हो जाएगा और संकेत पकड़ना शुरू कर देगा।",
  monitors_wizard_tips: "सेटअप में लगभग 2 मिनट लगते हैं",
  create_first_monitor: "अपना पहला मॉनिटर बनाइए",

  monitors_trigger_types_str: "भर्ती · समाचार · विज्ञापन",
  custom_interval: "कस्टम अंतराल",
  monitors_wizard_define_trigger_title: "अपना ट्रिगर तय करें",
  monitors_wizard_define_trigger_desc:
    "देखने वाले सिग्नल चुनें और मिलान को सीमित करने के लिए फ़िल्टर सेट करें। आप किसी भी कंपनी या किसी खास समूह को ट्रैक कर सकते हैं।",
  monitors_wizard_enrich_signal_data_title: "सिग्नल डेटा को समृद्ध करें",
  monitors_wizard_enrich_signal_data_desc:
    "वैकल्पिक रूप से कंपनी विवरण जोड़ें या व्यक्ति खोज चलाकर मेल खाती कंपनियों में सही संपर्क खोजें।",
  monitors_wizard_choose_destination_title: "अपना गंतव्य चुनें",
  monitors_wizard_choose_destination_desc:
    "मेल खाते सिग्नल डेटा को Webhook, ईमेल या जुड़े हुए टूल पर भेजें। समन्वय अंतराल तय करें - तुरंत से लेकर दैनिक तक।",
  monitors_wizard_example_title: "उदाहरण मॉनिटर",

  presets: "पूर्वनिर्धारित विकल्प",

  // flow
  monitors_flow_company_enrichment: "कंपनी समृद्धि",
  destination: "गंतव्य",
  add_filter: "फ़िल्टर जोड़ें",
  field: "फ़ील्ड",
  operator: "ऑपरेटर",
  real_time: "तुरंत",

  monitors_create_company_first_one_company_at_least:
    "कृपया निगरानी के लिए कम से कम एक कंपनी जोड़ें।",
  monitors_create_signal_types_one_at_least:
    "आगे बढ़ने के लिए कृपया कम से कम एक सिग्नल प्रकार चुनें।",
  monitors_create_validation_signal_types_required:
    "देखने के लिए कम से कम एक सिग्नल प्रकार चुनें।",
  monitors_create_validation_email_required:
    "कम से कम एक प्राप्तकर्ता ईमेल पता जोड़ें।",
  monitors_create_validation_name_required:
    "अपने मॉनिटर को एक नाम दें ताकि आप इसे बाद में ढूंढ सकें।",

  credits_cost: "0 क्रेडिट | 1 क्रेडिट | {count} क्रेडिट",

  // try
  monitor_try_popover_title: "इस मॉनिटर को आज़माएँ",
  monitor_try_popover_desc:
    "चलाने के लिए एक तारीख चुनें। यदि परिणाम मिलते हैं, तो क्रेडिट खर्च होंगे।",
  monitor_try_popover_form_date_label: "तारीख",
  monitor_try_popover_max_results_label: "अधिकतम परिणाम",
  run_query: "क्वेरी चलाएँ",
  monitors_try_button: "परीक्षण क्वेरी चलाएँ",

  // list aside filters
  last_trigger_at_descending: "आखिरी ट्रिगर (नया पहले)",
  last_trigger_at_ascending: "आखिरी ट्रिगर (पुराना पहले)",
  name_ascending: "Name (A-Z)",
  name_descending: "Name (Z-A)",

  // signals
  news: "समाचार",
  jobs: "भर्ती",
  signal_types: "सिग्नल प्रकार",
  news_filter: "समाचार फ़िल्टर",
  jobs_filter: "भर्ती फ़िल्टर",
  advertisements_filter: "विज्ञापन फ़िल्टर",
  global_filters: "वैश्विक फ़िल्टर",

  company_enrichment_enable_desc:
    "आकार, उद्योग, मुख्यालय और प्रोफ़ाइल जोड़े गए",
  company_enrichment_enable_fields: "आकार, उद्योग, मुख्यालय, प्रोफ़ाइल",
  off: "बंद",

  max_people_count: "अधिकतम 0 लोग | अधिकतम 1 व्यक्ति | अधिकतम {count} लोग",
  "monitor_detail_logs-table-empty-title": "अभी तक कोई लॉग नहीं",
  "monitor_detail_logs-table-empty-desc":
    "जब यह मॉनिटर सिग्नल प्राप्त करना शुरू करेगा, लॉग यहाँ दिखाई देंगे। अपना पहला इवेंट सक्रिय करने के लिए परीक्षण क्वेरी चलाएँ।",

  signal: "सिग्नल",
  detection: "पहचान",
  monitor_detail_logs_payload_sent: "भेजा गया पेलोड",
  monitor_detail_logs_payload_received: "प्रतिक्रिया",
  monitor_detail_logs_trigger_config: "ट्रिगर विन्यास",

  create_monitor: "मॉनिटर बनाएँ",
  update_monitor: "मॉनिटर अपडेट करें",

  monitors_edit_title: "मॉनिटर संपादित करें",
  global: "वैश्विक",
  navMonitorsDesc:
    "कंपनियों को ट्रैक करें और जब उनसे संपर्क करने का सही कारण हो, तब सूचना पाएँ।",

  trigger_limits: "ट्रिगर सीमाएँ",
  monitor_not_found: "मॉनिटर नहीं मिला",
  please_select_field_and_operator_first: "कृपया पहले फ़ील्ड और ऑपरेटर चुनें",

  people_count: "0 लोग | 1 व्यक्ति | {count} लोग",
  search_fee: "खोज शुल्क {0} क्रेडिट",
  email_cost: "ईमेल रिडेम्प्शन शुल्क {0} क्रेडिट",
  phone_cost: "फोन रिडेम्प्शन शुल्क {0} क्रेडिट",
  estimated_cost: "अनुमानित लागत:",
  monitors_create_enrichment_people_search_config_item_credits_message:
    "अनुमानित लागत: न्यूनतम <strong>{0}</strong>, अधिकतम <strong>{1}</strong> = {2}",

  monitor_estimate_cost_title: "प्रति ट्रिगर अनुमानित लागत",
  monitor_estimate_cost_max_record:
    "अधिकतम 0 रिकॉर्ड | अधिकतम 1 रिकॉर्ड | अधिकतम {count} रिकॉर्ड",
  credits_cost_range: "{0} क्रेडिट",
  signal_detection: "सिग्नल पहचान",
  matched_companies:
    "0 मिलान कंपनियां | 1 मिलान कंपनी | {count} मिलान कंपनियां",
  min_prefix: "न्यूनतम: ",
  max_prefix: "अधिकतम: ",

  recovered: "ठीक हो गया",
  breakdown: "विस्तृत विवरण",
  monitor_estimate_cost_fixed_per_trigger: "प्रति ट्रिगर निश्चित लागत",
  credits_cost_short: "0 क्र | 1 क्र | {count} क्र",
  credits_cost_short_per_company: "0 क्र/कं | 1 क्र/कं | {count} क्र/कं",
  monitor_estimate_cost_per_match_company: "प्रत्येक मिलान कंपनी",
  monitor_estimate_cost_per_company_subtotal: "प्रति कंपनी उप-कुल",
  monitor_estimate_cost_redeem_cost: "प्रत्येक मिलान कंपनी की रिडीम लागत",
  monitor_estimate_cost_redeem_subtotal: "रिडीम उप-कुल",
  monitor_estimate_cost_redeem_list_name: "PS{0} {1} × {2} लोग",
  monitor_estimate_cost_fixed_desc:
    "सिग्नल पहचान एक निश्चित लागत है — प्रति ट्रिगर एक बार ली जाती है, चाहे कितनी भी कंपनियाँ मेल खाएँ।",
  monitor_estimate_cost_fixed: "निश्चित लागत",
  redeems: "रिडीम",
  company_count_short: "0 कं | 1 कं | {count} कं",

  monitor_sequence_summary_step_count: "0 चरण | 1 चरण | {count} चरण",
  monitor_sequence_summary_contact_count:
    "0 संपर्क | 1 संपर्क | {count} संपर्क",
  search_sequence: "अनुक्रम खोजें",
  create_new_sequence: "नया अनुक्रम बनाएँ",
  draft: "ड्राफ़्ट",

  monitors_create_delivery_sequence_who_enrolled_title:
    "किसे नामांकित किया जाएगा",
  monitors_create_delivery_sequence_edit_in_enrichment:
    "समृद्धि में संपादित करें",
  monitors_create_delivery_sequence_who_enrolled_tip:
    "समृद्धि में कॉन्फ़िगर किए गए स्रोत। अनुक्रम नामांकन के लिए प्रत्येक को चालू या बंद करें — मानदंड समृद्धि में सेट है, यहाँ नहीं।",
  monitor_create_delivery_sequence_company_contact: "कंपनी संपर्क",
  monitor_create_delivery_sequence_company_contact_desc:
    "सर्वश्रेष्ठ मिलान प्रोफ़ाइल · कंपनी प्रोफ़ाइल से",
  enrolling: "नामांकित हो रहा है",
  not_enrolling: "नामांकित नहीं हो रहा",
  monitor_sequence_who_enrolled_people_title: "लोग - व्यक्ति खोज से",

  monitor_create_delivery_sequence_enroll_behavior_title: "नामांकन व्यवहार",
  monitor_create_delivery_sequence_enroll_behavior_desc:
    "प्रत्येक संपर्क परिदृश्य में क्या होगा, यह परिभाषित करें। सभी नियम हर नामांकित स्रोत पर लागू होते हैं।",

  monitor_create_delivery_sequence_enroll_behavior_new_contact_title:
    "नया संपर्क",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_desc:
    "अभी तक इस अनुक्रम में नामांकित नहीं",
  start_at: "यहाँ से शुरू करें",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_placeholder:
    "जैसे: चरण 1 या चरण 2",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_title:
    "पहले से लक्षित अनुक्रम में है",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_desc:
    "इस मॉनिटर द्वारा उपयोग किए जाने वाले सटीक अनुक्रम में सक्रिय है",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_placeholder:
    "जैसे: चरण 1 से पुनः शुरू करें",
  skip: "छोड़ें",
  people_search: "व्यक्ति खोज",
  no_config_in_enrichment: "समृद्धि में कॉन्फ़िगर नहीं किया गया",
  fetch_sequence_steps_failed: "अनुक्रम चरण प्राप्त करने में विफल",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_option:
    "चरण {index} - {step}",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_option:
    "चरण {index} - {step} से पुनः शुरू करें",

  // हिंदी
  monitors_matched_deliver_signal_title: "कंपनी और सिग्नल",
  monitors_matched_deliver_signal_desc:
    "कंपनी का नाम और वह सिग्नल जिसने मैच को ट्रिगर किया",
  monitors_matched_deliver_people_search_desc:
    "ईमेल में नाम, पदनाम और संपर्क जानकारी के साथ सूचीबद्ध",
  monitors_matched_deliver_title: "हर मैच में मिलता है",
  to_somewhere: "{destination} पर",
  monitor_create_delivery_sequence_people_contact: "लोग संपर्क",
  monitor_create_delivery_sequence_people_contact_desc:
    "सभी सक्रिय पीपल सर्च ब्लॉक्स से",
  selected_sequence_not_exist: "चयनित अनुक्रम मौजूद नहीं है",
  monitors_create_delivery_sequence_enrichment_invalid:
    "कृपया लोग संपर्क, कंपनी संपर्क या दोनों जोड़ें।",
  monitors_create_delivery_sequence_required:
    "जारी रखने के लिए कृपया एक अनुक्रम चुनें।",
  failing: "असफल",
  monitor_create_delivery_sequence_warning_title: "अज्ञात अनुक्रम",
  monitor_create_delivery_sequence_warning_desc:
    "अनुक्रम हटा दिया गया है — कृपया एक विकल्प चुनें",
  deleted: "हटा दिया गया",
  owner: "मालिक",
  not_triggered_yet: "अभी तक ट्रिगर नहीं हुआ",
};

export const monitors_ko = {
  off_company_enrichment_desc: "꺼짐 — 일치 항목에 회사명과 시그널만 포함됩니다",
  add_company_details: "회사 정보 추가",
  off_people_search_desc: "꺼짐 — 일치한 회사에서 연락처를 찾지 않습니다",
  add_people_search: "인물 검색 추가",
  monitor_flow_sequence_deleted_title:
    "할당된 시퀀스가 <span>삭제</span>되어 이 모니터에는 대상이 없습니다. <span>비활성</span> 상태로 설정되었으며, 새 대상을 연결하기 전까지 일치하는 레코드를 전송하지 않습니다.",
  monitor_create_delivery_sequence_warning_assign_button: "새 대상 할당",
  // data export
  monitors_download_data_include: "포함",
  monitors_download_data_records: "{0}개 레코드",
  monitors_download_data_layout: "레이아웃",
  monitors_download_data_layout_one_sheet: "단일 시트",
  monitors_download_data_layout_one_sheet_desc: "회사당 한 행, 인물 병합",
  monitors_download_data_layout_separate: "개별 파일",
  monitors_download_data_layout_separate_desc: "유형별 파일 1개 (.zip)",
  monitors_download_data_summary: "약 {0}행 · CSV",
  monitors_download_data_truncated: "내보내기 한도 도달 — 범위를 좁히세요",
  monitors_export_logs_title: "트리거 로그",
  monitors_export_logs_desc: "상태, 크레딧 및 원본 페이로드",
  monitors_export_data_title: "신호 데이터",
  monitors_export_data_desc: "회사, 인물 및 신호",
  monitors_download_data_title: "데이터 다운로드",
  monitors_download_data_desc:
    "각 트리거의 신호, 회사, 인물을 내보냅니다 — 대상에 전송되는 것과 동일한 데이터입니다.",
  monitors_download_data_type: "데이터 유형",
  monitors_download_data_type_companies: "회사",
  monitors_download_data_type_signals: "신호",
  monitors_download_data_type_people: "인물",
  monitors_download_data_scope: "범위",
  monitors_download_data_scope_selected: "선택한 트리거 ({0})",
  monitors_download_data_scope_range: "날짜 범위",
  monitors_download_data_range_start: "시작 날짜",
  monitors_download_data_range_end: "종료 날짜",
  monitors_download_data_people_hint:
    "인물 행은 이 모니터가 인물을 보강할 때만 표시됩니다.",
  monitors_download_data_confirm: "CSV 다운로드",
  // list
  monitors_list_item_statistic_tiggers_today: "오늘 트리거 수",
  monitors_list_item_statistic_tiggers_today_desc: "어제 대비 {0}%",
  monitors_list_item_statistic_last_trigger: "마지막 트리거",
  monitors_list_item_statistic_today_trigger_count: "오늘",
  monitors_list_item_statistic_success_rate: "성공률",
  avg_per_day: "일 평균",
  last_7_days: "최근 7일",
  success_rate: "성공률",
  monitors_list_aside_skeleton_content:
    "첫 번째 모니터를 생성해 시그널을 추적하고, 조건이 일치할 때 알림을 받으세요.",

  //   create
  save_draft_and_exit: "초안 저장 후 나가기",
  monitors_draft_system_name: "{subject} — 초안 · {date}",
  back_to_monitors: "모니터 목록으로 돌아가기",
  monitors_create_title: "모니터 설정",
  monitors_create_header_desc:
    "4단계(미리보기)에서 이 모니터의 이름을 지정하세요",
  monitors_edit_header_desc:
    "4단계(미리보기)에서 이 모니터의 이름을 변경하세요",
  new_monitor: "새 모니터",
  monitors_create_flow_title: "모니터 플로우",
  monitors_create_step_trigger: "트리거",
  monitors_create_step_enrichment: "데이터 보강",
  monitors_create_step_delivery: "전송",
  monitors_create_step_preview: "미리보기",
  monitor_create_bottom_desc:
    "{step_total}단계 중 <span class='monitors-container-create-bottom-desc-heavy'>{step}</span>단계 ·  <span class='monitors-container-create-bottom-desc-heavy'>{step_name}</span> {step_desc}",

  monitors_create_step_trigger_desc: "무엇을 감시할지 선택하세요.",
  monitors_create_step_enrichment_desc:
    "선택적으로 회사 정보나 연락처를 추가하세요.",
  monitors_create_step_delivery_desc: "일치 항목을 보낼 위치를 선택하세요.",
  monitors_create_step_preview_desc: "모든 내용을 검토한 후 생성하세요.",

  //  create trigger
  monitors_create_signal_trigger_header_title: "시그널 트리거",
  monitors_create_signal_trigger_header_desc:
    "시그널은 기업에서 발생하는 이벤트입니다. 이 트리거가 모니터를 무엇으로 시작할지 결정합니다.",

  monitors_create_signal_trigger_detection_mode_title: "탐지 모드",
  monitors_create_signal_trigger_detection_mode_desc:
    " — 무엇부터 시작하시겠어요?",
  signal_first: "시그널 우선",
  monitors_create_signal_trigger_detection_mode_signal_first_title:
    "이벤트 유형",
  monitors_create_signal_trigger_detection_mode_signal_first_desc:
    "필터에 일치하는 모든 회사에서 뉴스, 채용, 확장 같은 신호를 감시합니다.",
  monitors_create_signal_trigger_detection_mode_signal_first_eg:
    "예: <span>MY에서 Sales를 채용 중인 회사, 또는 APAC에서 광고를 집행 중이고 규모가 100명 이상인 회사</span>",
  company_first: "회사 우선",
  monitors_create_signal_trigger_detection_mode_company_first_title:
    "내가 아는 특정 기업",
  monitors_create_signal_trigger_detection_mode_company_first_desc:
    "이미 관심 있는 회사를 선택하고, 해당 회사에서 어떤 시그널이든 발생하면 알림을 받으세요.",
  monitors_create_signal_trigger_detection_mode_company_first_eg:
    "예: <span>Amazon과 Google의 신규 지역 News 또는 홍콩 Jobs를 모니터링</span>",
  monitors_create_signal_trigger_signal_types_label: "시그널 유형",
  monitors_create_signal_trigger_signal_types_label_addition:
    " — 어떤 이벤트인가요?",
  monitors_create_signal_trigger_signal_types_tips:
    "각 시그널은 독립적으로 트리거됩니다. 동시에 발생할 필요 없이 하나만 발생해도 알림을 받게 됩니다.",

  monitor_create_signal_breakdown: "<span>범위 좁히기</span>  · 선택 사항",
  monitor_create_signal_breakdown_desc:
    "선택 사항 — 더 적고 구체적인 일치를 위해 필터를 추가하세요.",

  condition_count: "조건 0개 | 조건 1개 | 조건 {count}개",

  monitors_create_signal_trigger_company_filter_title: "어떤 기업이 해당되나요",
  monitors_create_signal_trigger_company_filter_tag: "모든 시그널에 적용",
  monitors_create_signal_trigger_company_filter_desc:
    "규모, 산업, 본사 국가, 기술 스택 등 기업 속성.",

  monitors_create_signal_trigger_company_monitor_title: "모니터링할 회사",
  monitors_create_signal_trigger_company_monitor_placeholder:
    "여러 회사 추가...",
  add_filter_condition: "필터 조건 추가",
  monitors_create_signal_trigger_company_filter_label: "기업 기준",
  monitors_create_signal_trigger_company_filter_label_addition:
    " — 어떤 기업을 대상으로 하나요?",
  monitors_create_signal_trigger_signal_filter_label: "시그널 조건",
  monitors_create_signal_trigger_signal_filter_label_addition:
    " — 특정 이벤트 세부 정보가 있나요?",
  monitors_create_signal_trigger_max_record_title: "트리거당 최대 레코드 수",
  monitors_create_signal_trigger_max_record_desc:
    "한 번의 트리거에서 처리할 일치 회사 수를 제한합니다. 데이터 보강과 인물 검색은 각 레코드마다 실행되므로, 이 제한은 광범위한 시그널에서 예상치 못한 크레딧 소모를 막아줍니다.",

  tabNews_desc: "기업이 뉴스에 등장합니다",
  tabJobPostings_desc: "기업이 채용 중입니다",
  ads_desc: "기업이 광고를 시작합니다",
  expansions_desc: "기업이 성장하거나 확장하고 있습니다",

  monitors_create_signal_trigger_max_record_tips:
    "1단계에서 설정 - 변경하려면 돌아가기",
  monitors_create_signal_trigger_detection_mode_warning_1:
    "전역 필터가 초기화되었습니다",
  monitors_create_signal_trigger_detection_mode_warning_2:
    "최근 매칭 결과가 초기화되었습니다",
  monitors_create_signal_trigger_detection_mode_warning_3:
    "Webhook payload가 변경되었습니다",
  monitors_create_signal_trigger_detection_mode_switch_to_signal_first:
    "시그널 우선으로 전환",
  monitors_create_signal_trigger_detection_mode_switch_to_company_first:
    "회사 우선으로 전환",
  //   create enrichment
  monitors_create_enrichment_header_title: "데이터 보강 및 검증",
  monitors_create_enrichment_header_desc:
    "전송 전에 시그널 데이터를 보강하거나 AI 조건을 적용해 검증할 수 있습니다",
  monitors_create_enrichment_company_details_title: "회사 상세 정보",
  monitors_create_enrichment_company_details_cost:
    "조회당 0크레딧 | 조회당 1크레딧 | 조회당 {count}크레딧",

  monitors_matched_deliver_company_detail_desc:
    "{destination}에 전체 회사 프로필로 표시됩니다",

  monitors_create_enrichment_company_details_desc:
    "일치한 각 시그널에 규모, 산업, HQ, 회사 프로필을 추가합니다",
  monitors_create_enrichment_company_details_tips:
    "<span>가장 적합한 경우</span>: 회사 적합성에 따라 자격을 평가하거나 분류할 때. 이미 회사를 알고 있다면 <span>꺼 두세요</span>.",

  monitors_create_enrichment_people_search_title: "인물 검색",

  monitors_create_enrichment_people_search_cost:
    "검색당 0크레딧 | 검색당 1크레딧 | 검색당 {count}크레딧",
  monitors_create_enrichment_people_search_desc:
    "각 시그널마다 하나 이상의 인물 검색을 실행할 수 있으며, 각 검색은 자체 필터를 가집니다. 결과는 출력에서 그룹으로 정리됩니다.",
  monitors_create_enrichment_people_search_tips:
    "<span>가장 적합한 경우</span>: 자동으로 시작하려는 아웃리치에 적합합니다. 어떤 회사가 활동 중인지만 알면 되는 경우 <span>꺼 두세요</span>.",
  monitors_create_enrichment_people_search_config_item_max_people_to_return:
    "반환할 최대 인원 수",

  monitors_create_enrichment_people_search_config_item_redeem_contact_info:
    "연락처 정보 차감 사용",
  monitors_create_enrichment_people_search_config_item_redeem_credits:
    "인당 0크레딧 | 인당 1크레딧 | 인당 {count}크레딧",
  monitors_create_enrichment_people_search_config_add_one: "인물 검색 추가",
  monitors_create_enrichment_people_search_config_tips:
    "각 검색은 독립적으로 실행됩니다. 검색 비용은 검색당 부과되며, 이메일과 전화번호 차감은 반환된 인원별로 별도 과금됩니다.",
  monitors_create_enrichment_people_search_config_item_advanced_title:
    "<span>고급 필터</span>  · 선택 사항",
  monitors_create_enrichment_people_search_config_item_advanced_desc:
    "리스트나 시퀀스에 이미 있는 사람으로 좁히기",
  monitors_create_enrichment_people_search_config_item_advanced_tips:
    "리스트나 시퀀스에 <span>이미</span> 있는 사람만 반환합니다. 전체를 검색하려면 비워 두세요. 재참여에 유용합니다.",
  monitors_create_enrichment_people_search_config_item_advanced_label_saved_list:
    "저장된 리스트에 이미 있음",
  monitors_create_enrichment_people_search_config_item_advanced_label_sequence:
    "시퀀스에 이미 있음",

  // create-delivery
  destination_type: "대상 유형",
  monitors_create_delivery_title: "대상 및 전송",
  monitors_create_delivery_desc:
    "시그널을 어디로 얼마나 자주 보낼지 정의합니다",
  monitors_create_delivery_type_next_release: "v2.0",
  webhook: "Webhook",
  monitors_create_delivery_type_webhook_desc:
    "시그널 데이터를 자체 시스템 또는 서드파티 툴로 전송합니다",
  monitors_create_delivery_type_email_title: "Email",
  monitors_create_delivery_type_email_desc:
    "이메일로 읽기 쉬운 시그널 요약을 받습니다",
  monitors_create_delivery_type_sequences_title: "Sequences",
  monitors_create_delivery_type_sequences_desc:
    "일치한 연락처를 아웃리치 시퀀스에 자동 등록합니다",
  monitors_create_delivery_type_sheets_title: "Sheets",
  monitors_create_delivery_type_sheets_desc:
    "일치한 시그널을 원하는 데이터 대상과 동기화합니다",

  monitors_create_delivery_configuration_webhook: "Webhook 설정",
  monitors_create_delivery_configuration_email: "Email 설정",
  monitors_create_delivery_configuration_sequences: "Sequences 설정",
  monitors_create_delivery_configuration_sheets: "Sheets 설정",

  monitors_create_delivery_email_send_to_label: "전송 대상",
  monitors_create_delivery_email_send_to_placeholder: "johndoe@example.com",
  monitors_create_delivery_configuration_webhook_endpoint_url: "Endpoint URL",
  monitors_create_delivery_configuration_webhook_endpoint_url_placeholder:
    "https://your-webhook.site",
  monitors_create_delivery_headers: "Headers",
  optional: "선택 사항",
  monitors_create_delivery_add_headers: "Header 추가",
  monitors_create_delivery_body: "Body 파라미터",
  monitors_create_delivery_add_body: "파라미터 추가",
  monitors_create_key: "키",
  monitors_create_value: "값",
  monitors_create_delivery_alert_message_label: "실패 알림 이메일",
  monitors_create_delivery_alert_message_placeholder:
    "엔드포인트 실패 시 이 주소로 알림",
  monitors_create_delivery_run_test_webhook_title: "엔드포인트 검증",
  monitors_create_delivery_run_test_webhook_desc:
    "테스트 payload를 전송해 서버가 정상적으로 수신하는지 확인합니다",
  monitors_create_delivery_run_test_email_title: "이메일 검증",
  monitors_create_delivery_run_test_email_desc:
    "테스트 이메일을 전송해 주소가 정상적으로 수신하는지 확인합니다",
  monitors_create_delivery_run_test_button: "테스트 전송",

  monitors_create_header_key_placeholder: "예: Authorization",
  monitors_create_header_value_placeholder: "예: Bearer your token",

  //   create preview
  monitors_create_preview_title: "검토 후 생성",
  monitors_create_preview_desc: "실행 전에 설정 내용을 확인하세요",
  monitors_create_preview_define_name_title: "모니터 이름 ",
  monitors_create_preview_define_name_placeholder:
    "예: Hiring - Sales in MY (foreign cos, 100+)",
  monitors_create_preview_tips:
    "API key (X-Pubrio-Signature)는 생성 후 발급되며 Settings 탭에서 즉시 확인할 수 있습니다.",

  monitors_create_preview_summary:
    "이 모니터는 <span>{companies}</span>에서 <span>{signals}</span>을(를) 감시한 다음, 일치 항목을 <span>{destination}</span>(으)로 전송하며, {interval}(으)로 확인합니다.",
  any_matching_companies: "일치하는 모든 회사",

  // detail settings
  monitor: "모니터",
  monitors: "모니터",
  delivery: "전송",
  sync_interval: "동기화 주기",
  sync_interval_description: "새 시그널을 확인하는 빈도",
  alert_email: "알림 이메일",
  alert_email_description:
    "실패가 발생하거나 이 모니터가 자동 일시중지되면 이메일로 알려드립니다",

  failure_handle: "실패 처리",
  failure_handle_retry_attempts: "재시도 횟수",
  failure_handle_retry_attempts_desc:
    "전송을 실패로 표시하기 전에 몇 번 재시도할지 설정합니다",
  failure_handle_retry_delay: "재시도 간격",
  failure_handle_retry_delay_desc:
    "각 재시도 사이에 얼마나 기다릴지 설정합니다",
  failure_handle_auto_pause_failures_count: "연속 실패 후 자동 일시중지",
  failure_handle_auto_pause_failures_count_desc:
    "크레딧 낭비를 막기 위해 Pubrio가 이 모니터를 자동으로 비활성화합니다. 실패 알림 이메일도 함께 수신됩니다",
  failure_handle_daily_trigger_cap: "일일 트리거 한도",
  failure_handle_daily_trigger_cap_desc:
    "하루 최대 트리거 수로 크레딧 사용량을 제어합니다. 0 = 무제한",
  security: "보안",
  monitors_list_detail_settings_security_api_key_title:
    "API key (X-Pubrio-Signature)",
  monitors_list_detail_settings_security_api_key_description:
    "서버 측 검증 로직에 추가하세요",
  copied: "복사됨",

  //   detail tabs
  monitors_detail_tab_flow: "플로우",

  // wizard
  getting_started: "시작하기",
  monitors_wizard_introduction_title:
    "시그널을 추적하고 일치 항목을 자동으로 라우팅하세요",
  monitors_wizard_introduction_desc:
    "모니터는 채용, 뉴스, 광고, 투자 유치 등 관심 있는 시그널을 감지한 다음, 일치하는 항목마다 정보를 보강하여 원하는 곳으로 전송합니다. 세 단계로 설정을 완료하세요.",
  // Wizard guided tour (driver.js)
  monitor_wizard_tour_step_1_title: "환영합니다 — 구매 시그널을 포착해 보세요",
  monitor_wizard_tour_step_1_desc:
    "모니터는 채용이나 투자 유치 같은 시그널을 감지하기 위해 기업을 관찰하다가, 일치하는 항목이 생기는 순간 알려드립니다. 첫 번째 모니터를 만들어 봅시다.",
  monitor_wizard_tour_step_2_title: "무엇을 감시할지부터 선택하세요",
  monitor_wizard_tour_step_2_desc:
    "중요한 시그널을 선택하세요: 채용, 뉴스, 광고, 확장. 그중 어느 하나라도 발생하면 알려드립니다.",
  monitor_wizard_tour_step_3_title: "완성되어 가는 과정을 확인하세요",
  monitor_wizard_tour_step_3_desc:
    "이 실시간 미리보기는 모니터를 파이프라인으로 보여줍니다. 무엇이 트리거하는지, 무엇을 추가하는지, 어디로 보내는지 포함됩니다.",
  monitor_wizard_tour_step_4_title: "활용할 정보를 추가하세요",
  monitor_wizard_tour_step_4_desc:
    "회사 정보나 실제 연락처를 켜서 모든 일치 항목이 단순한 이름이 아니라 바로 실행 가능한 상태가 되도록 하세요.",
  monitor_wizard_tour_step_5_title: "일치 항목을 업무 공간으로 전송하세요",
  monitor_wizard_tour_step_5_desc:
    "이메일, 시퀀스, 스프레드시트 또는 직접 사용하는 도구. 일치 항목을 처리할 위치를 선택하세요.",
  monitor_wizard_tour_step_6_title: "무엇을 얻게 될지 정확히 확인하세요",
  monitor_wizard_tour_step_6_desc:
    "이 패널은 각 일치 항목이 무엇을 제공하는지 항상 보여주므로, 완료하기 전에 그 가치를 알 수 있습니다.",
  monitor_wizard_tour_step_7_title: "준비되었습니다! 만들어 보세요!",
  monitor_wizard_tour_step_7_desc:
    "마지막 화면을 진행하고 '생성'을 누르세요. 모니터가 실시간으로 작동하며 시그널을 포착하기 시작합니다.",
  monitors_wizard_tips: "설정에는 약 2분이 소요됩니다",
  create_first_monitor: "첫 번째 모니터 만들기",

  monitors_trigger_types_str: "채용 · 뉴스 · 광고",
  custom_interval: "사용자 지정 주기",
  monitors_wizard_define_trigger_title: "트리거 정의",
  monitors_wizard_define_trigger_desc:
    "추적할 시그널을 선택하고 필터를 설정해 매칭 범위를 좁히세요. 전체 회사를 대상으로 하거나 특정 회사 집합만 추적할 수 있습니다.",
  monitors_wizard_enrich_signal_data_title: "시그널 데이터 보강",
  monitors_wizard_enrich_signal_data_desc:
    "회사 상세 정보를 추가하거나 인물 검색을 실행해 일치한 회사의 적합한 연락처를 찾을 수 있습니다.",
  monitors_wizard_choose_destination_title: "대상 선택",
  monitors_wizard_choose_destination_desc:
    "일치한 시그널 데이터를 webhook, email 또는 연결된 도구로 전송하세요. 실시간부터 일 단위까지 동기화 주기를 설정할 수 있습니다.",
  monitors_wizard_example_title: "모니터 예시",

  presets: "프리셋",

  // flow
  monitors_flow_company_enrichment: "회사 데이터 보강",
  destination: "대상",
  add_filter: "필터 추가",
  field: "필드",
  operator: "연산자",
  real_time: "실시간",

  monitors_create_company_first_one_company_at_least:
    "모니터링할 회사를 최소 한 곳 이상 추가해 주세요.",
  monitors_create_signal_types_one_at_least:
    "계속하려면 시그널 유형을 하나 이상 선택해 주세요.",
  monitors_create_validation_signal_types_required:
    "모니터링할 시그널 유형을 하나 이상 선택하세요.",
  monitors_create_validation_email_required:
    "받는 사람 이메일 주소를 하나 이상 추가하세요.",
  monitors_create_validation_name_required:
    "나중에 찾을 수 있도록 모니터 이름을 입력하세요.",

  credits_cost: "0크레딧 | 1크레딧 | {count}크레딧",

  // try
  monitor_try_popover_title: "이 모니터 테스트",
  monitor_try_popover_desc:
    "실행할 날짜를 선택하세요. 결과가 있으면 크레딧이 차감됩니다.",
  monitor_try_popover_form_date_label: "날짜",
  monitor_try_popover_max_results_label: "최대 결과 수",
  run_query: "쿼리 실행",
  monitors_try_button: "테스트 쿼리 실행",

  // list aside filters
  last_trigger_at_descending: "마지막 트리거 (최신순)",
  last_trigger_at_ascending: "마지막 트리거 (오래된순)",
  name_ascending: "이름 (A-Z)",
  name_descending: "이름 (Z-A)",

  // signals
  news: "뉴스",
  jobs: "채용",
  signal_types: "시그널 유형",
  news_filter: "News 필터",
  jobs_filter: "Jobs 필터",
  advertisements_filter: "Advertisements 필터",
  global_filters: "전역 필터",

  company_enrichment_enable_desc: "규모, 산업, HQ, 프로필 추가됨",
  company_enrichment_enable_fields: "규모, 산업, HQ, 프로필",
  off: "꺼짐",

  max_people_count: "최대 0명 | 최대 1명 | 최대 {count}명",
  "monitor_detail_logs-table-empty-title": "아직 로그가 없습니다",
  "monitor_detail_logs-table-empty-desc":
    "이 모니터가 시그널을 수신하기 시작하면 로그가 여기에 표시됩니다. 첫 이벤트를 발생시키려면 테스트 쿼리를 실행해 보세요.",

  signal: "시그널",
  detection: "탐지",
  monitor_detail_logs_payload_sent: "payload sent",
  monitor_detail_logs_payload_received: "response",
  monitor_detail_logs_trigger_config: "trigger config",

  create_monitor: "모니터 생성",
  update_monitor: "모니터 업데이트",

  monitors_edit_title: "모니터 편집",
  global: "전역",
  navMonitorsDesc:
    "회사를 추적하고, 연락할 만한 이유가 생기면 바로 알림을 받으세요.",

  trigger_limits: "트리거 제한",
  monitor_not_found: "모니터를 찾을 수 없습니다",
  please_select_field_and_operator_first: "먼저 필드와 연산자를 선택해 주세요",

  people_count: "0명 | 1명 | {count}명",
  search_fee: "검색 비용 {0}크레딧",
  email_cost: "이메일 리딤 비용 {0}크레딧",
  phone_cost: "전화번호 리딤 비용 {0}크레딧",
  estimated_cost: "예상 비용:",
  monitors_create_enrichment_people_search_config_item_credits_message:
    "예상 비용: 최소 <strong>{0}</strong>, 최대 <strong>{1}</strong> = {2}",

  monitor_estimate_cost_title: "트리거당 예상 비용",
  monitor_estimate_cost_max_record:
    "최대 0개 레코드 | 최대 1개 레코드 | 최대 {count}개 레코드",
  credits_cost_range: "{0}크레딧",
  signal_detection: "시그널 탐지",
  matched_companies:
    "일치한 회사 0개 | 일치한 회사 1개 | 일치한 회사 {count}개",
  min_prefix: "최소: ",
  max_prefix: "최대: ",

  recovered: "복구됨",
  breakdown: "비용 분석",
  monitor_estimate_cost_fixed_per_trigger: "트리거당 고정 비용",
  credits_cost_short: "0 cr | 1 cr | {count}cr",
  credits_cost_short_per_company:
    "0 cr / 기업 | 1 cr / 기업 | {count} cr / 기업",
  monitor_estimate_cost_per_match_company: "일치 회사당",
  monitor_estimate_cost_per_company_subtotal: "회사당 소계",
  monitor_estimate_cost_redeem_cost: "일치 회사당 리딤 비용",
  monitor_estimate_cost_redeem_subtotal: "리딤 소계",
  monitor_estimate_cost_redeem_list_name: "PS{0} {1} × {2}명",
  monitor_estimate_cost_fixed_desc:
    "시그널 탐지는 고정 비용으로, 일치한 회사 수에 관계없이 트리거당 한 번만 부과됩니다.",
  monitor_estimate_cost_fixed: "고정 비용",
  redeems: "리딤",
  company_count_short: "0개 기업 | 1개 기업 | {count}개 기업",

  monitor_sequence_summary_step_count: "0 단계 | 1 단계 | {count} 단계",
  monitor_sequence_summary_contact_count: "0명 | 1명 | {count}명",
  search_sequence: "시퀀스 검색",
  create_new_sequence: "새 시퀀스 만들기",
  draft: "초안",

  monitors_create_delivery_sequence_who_enrolled_title: "등록 대상",
  monitors_create_delivery_sequence_edit_in_enrichment: "데이터 보강에서 편집",
  monitors_create_delivery_sequence_who_enrolled_tip:
    "데이터 보강에서 구성된 소스입니다. 시퀀스 등록을 위해 각 항목을 켜거나 끄세요 — 기준은 여기가 아닌 데이터 보강에서 설정됩니다.",
  monitor_create_delivery_sequence_company_contact: "회사 연락처",
  monitor_create_delivery_sequence_company_contact_desc:
    "최적 매칭 프로필 · 회사 프로필에서",
  enrolling: "등록 중",
  not_enrolling: "등록 안 함",
  monitor_sequence_who_enrolled_people_title: "인물 - 인물 검색 결과",

  monitor_create_delivery_sequence_enroll_behavior_title: "등록 동작",
  monitor_create_delivery_sequence_enroll_behavior_desc:
    "각 연락처 시나리오에서 발생하는 동작을 정의합니다. 모든 규칙은 등록된 모든 소스에 적용됩니다.",

  monitor_create_delivery_sequence_enroll_behavior_new_contact_title:
    "신규 연락처",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_desc:
    "아직 이 시퀀스에 등록되지 않음",
  start_at: "시작 단계",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_placeholder:
    "예: 1단계 또는 2단계",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_title:
    "이미 대상 시퀀스에 있음",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_desc:
    "이 모니터가 사용하는 동일한 시퀀스에서 활성 상태",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_placeholder:
    "예: 1단계부터 다시 시작",
  skip: "건너뛰기",
  people_search: "인물 검색",
  no_config_in_enrichment: "데이터 보강에서 설정되지 않음",
  fetch_sequence_steps_failed: "시퀀스 단계를 가져오지 못했습니다",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_option:
    "{index}단계 - {step}",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_option:
    "{index}단계 - {step}에서 다시 시작",

  // 한국어
  monitors_matched_deliver_signal_title: "회사 및 시그널",
  monitors_matched_deliver_signal_desc: "회사명과 일치를 유발한 시그널",
  monitors_matched_deliver_people_search_desc:
    "이메일에 이름, 직책, 연락처 정보와 함께 표시됩니다",
  monitors_matched_deliver_title: "각 일치 항목 제공 내용",
  to_somewhere: "{destination}(으)로",
  monitor_create_delivery_sequence_people_contact: "사람 연락처",
  monitor_create_delivery_sequence_people_contact_desc:
    "모든 활성화된 인물 검색 블록에서",
  selected_sequence_not_exist: "선택한 시퀀스가 존재하지 않습니다.",
  monitors_create_delivery_sequence_enrichment_invalid:
    "사람 연락처, 회사 연락처 또는 둘 다 등록해 주세요.",
  monitors_create_delivery_sequence_required: "계속하려면 시퀀스를 선택하세요.",
  failing: "실패",
  monitor_create_delivery_sequence_warning_title: "알 수 없는 시퀀스",
  monitor_create_delivery_sequence_warning_desc:
    "시퀀스가 삭제되었습니다 — 대체 항목을 선택하세요",
  deleted: "삭제됨",
  owner: "소유자",
  not_triggered_yet: "아직 트리거되지 않음",
};

export const monitors_ja = {
  off_company_enrichment_desc: "オフ — 一致項目には企業名とシグナルのみが含まれます",
  add_company_details: "会社情報を追加",
  off_people_search_desc: "オフ — 一致した企業の連絡先を検索しません",
  add_people_search: "人物検索を追加",
  monitor_flow_sequence_deleted_title:
    "割り当てられたシーケンスが<span>削除</span>されたため、このモニターには送信先がありません。<span>非アクティブ</span>に設定され、新しい送信先を接続するまで一致したレコードは配信されません。",
  monitor_create_delivery_sequence_warning_assign_button:
    "新しい送信先を割り当てる",
  // data export
  monitors_download_data_include: "含める",
  monitors_download_data_records: "{0} 件",
  monitors_download_data_layout: "レイアウト",
  monitors_download_data_layout_one_sheet: "単一シート",
  monitors_download_data_layout_one_sheet_desc: "会社ごとに1行、人物を結合",
  monitors_download_data_layout_separate: "個別ファイル",
  monitors_download_data_layout_separate_desc: "種別ごとに1ファイル（.zip）",
  monitors_download_data_summary: "約 {0} 行 · CSV",
  monitors_download_data_truncated:
    "エクスポート上限に達しました — 範囲を狭めてください",
  monitors_export_logs_title: "トリガーログ",
  monitors_export_logs_desc: "ステータス・クレジット・生ペイロード",
  monitors_export_data_title: "シグナルデータ",
  monitors_export_data_desc: "企業・人物・シグナル",
  monitors_download_data_title: "データをダウンロード",
  monitors_download_data_desc:
    "各トリガーの背後にあるシグナル、企業、人物をエクスポートします — 配信先が受け取るデータと同じです。",
  monitors_download_data_type: "データ種別",
  monitors_download_data_type_companies: "企業",
  monitors_download_data_type_signals: "シグナル",
  monitors_download_data_type_people: "人物",
  monitors_download_data_scope: "範囲",
  monitors_download_data_scope_selected: "選択したトリガー ({0})",
  monitors_download_data_scope_range: "期間",
  monitors_download_data_range_start: "開始日",
  monitors_download_data_range_end: "終了日",
  monitors_download_data_people_hint:
    "人物の行は、このモニターが人物をエンリッチする場合にのみ表示されます。",
  monitors_download_data_confirm: "CSV をダウンロード",
  // list
  monitors_list_item_statistic_tiggers_today: "本日のトリガー数",
  monitors_list_item_statistic_tiggers_today_desc: "昨日比 {0}%",
  monitors_list_item_statistic_last_trigger: "最終トリガー",
  monitors_list_item_statistic_today_trigger_count: "本日",
  monitors_list_item_statistic_success_rate: "成功率",
  avg_per_day: "1日あたり平均",
  last_7_days: "直近 7 日間",
  success_rate: "成功率",
  monitors_list_aside_skeleton_content:
    "最初のモニターを作成してシグナルを追跡し、条件に一致した際に通知を受け取りましょう。",

  //   create
  save_draft_and_exit: "下書きを保存して終了",
  monitors_draft_system_name: "{subject} — 下書き · {date}",
  back_to_monitors: "モニター一覧に戻る",
  monitors_create_title: "モニターを設定",
  monitors_create_header_desc:
    "ステップ4（プレビュー）でこのモニターに名前を付けます",
  monitors_edit_header_desc:
    "ステップ4（プレビュー）でこのモニターの名前を変更します",
  new_monitor: "新規モニター",
  monitors_create_flow_title: "モニターフロー",
  monitors_create_step_trigger: "トリガー",
  monitors_create_step_enrichment: "データ拡張",
  monitors_create_step_delivery: "配信",
  monitors_create_step_preview: "プレビュー",
  monitor_create_bottom_desc:
    "ステップ <span class='monitors-container-create-bottom-desc-heavy'>{step}</span> / {step_total} ·  <span class='monitors-container-create-bottom-desc-heavy'>{step_name}</span> {step_desc}",

  monitors_create_step_trigger_desc: "何を監視するかを選びます。",
  monitors_create_step_enrichment_desc:
    "必要に応じて会社情報や連絡先を追加します。",
  monitors_create_step_delivery_desc: "一致した項目の送信先を選びます。",
  monitors_create_step_preview_desc: "すべてを確認してから作成します。",

  //  create trigger
  monitors_create_signal_trigger_header_title: "シグナルトリガー",
  monitors_create_signal_trigger_header_desc:
    "シグナルとは企業で発生するイベントです。このトリガーがモニターの起点を決定します。",

  monitors_create_signal_trigger_detection_mode_title: "検出モード",
  monitors_create_signal_trigger_detection_mode_desc: " — 何から始めますか？",
  signal_first: "シグナル優先",
  monitors_create_signal_trigger_detection_mode_signal_first_title:
    "イベントの種類",
  monitors_create_signal_trigger_detection_mode_signal_first_desc:
    "フィルターに一致するあらゆる企業について、ニュース・採用・拡大などの動きを監視します。",
  monitors_create_signal_trigger_detection_mode_signal_first_eg:
    "例: <span>MY で営業職を採用中の企業、または APAC で広告を実施し従業員数 100 名超の企業</span>",
  company_first: "企業優先",
  monitors_create_signal_trigger_detection_mode_company_first_title:
    "私が知っている特定の企業",
  monitors_create_signal_trigger_detection_mode_company_first_desc:
    "既に注目している企業を選び、その企業でいずれかのシグナルが発生したら通知を受け取ります。",
  monitors_create_signal_trigger_detection_mode_company_first_eg:
    "例: <span>Amazon と Google の新地域ニュース、または香港の求人を監視</span>",
  monitors_create_signal_trigger_signal_types_label: "シグナル種別",
  monitors_create_signal_trigger_signal_types_label_addition:
    " — どのイベント？",
  monitors_create_signal_trigger_signal_types_tips:
    "各シグナルは独立してトリガーされます。いずれか一つでも発生すれば通知され、同時発生は不要です。",

  monitor_create_signal_breakdown: "<span>絞り込む</span>  · 任意",
  monitor_create_signal_breakdown_desc:
    "任意 — フィルターを追加して、より少なく具体的な一致に絞り込みます。",

  condition_count: "0 件の条件 | 1 件の条件 | {count} 件の条件",

  monitors_create_signal_trigger_company_filter_title: "対象となる企業",
  monitors_create_signal_trigger_company_filter_tag: "すべてのシグナルに適用",
  monitors_create_signal_trigger_company_filter_desc:
    "規模、業種、本社所在国、技術スタックなどの企業属性。",

  monitors_create_signal_trigger_company_monitor_title: "監視対象の企業",
  monitors_create_signal_trigger_company_monitor_placeholder:
    "複数の企業を追加...",
  add_filter_condition: "フィルター条件を追加",
  monitors_create_signal_trigger_company_filter_label: "企業条件",
  monitors_create_signal_trigger_company_filter_label_addition:
    " — どの企業を対象に？",
  monitors_create_signal_trigger_signal_filter_label: "シグナル条件",
  monitors_create_signal_trigger_signal_filter_label_addition:
    " — 特定のイベントの詳細はありますか？",
  monitors_create_signal_trigger_max_record_title:
    "トリガーごとの最大レコード数",
  monitors_create_signal_trigger_max_record_desc:
    "1 回のトリガーで処理する一致企業数を制限します。データ拡張と人物検索は各レコードに対して実行されるため、この上限により広い条件での予期しないクレジット消費を防げます。",

  tabNews_desc: "企業がニュースに取り上げられる",
  tabJobPostings_desc: "企業が採用を行っている",
  ads_desc: "企業が広告を開始する",
  expansions_desc: "企業が成長または拡大している",

  monitors_create_signal_trigger_max_record_tips:
    "ステップ 1 で設定します。変更するには戻ってください",
  monitors_create_signal_trigger_detection_mode_warning_1:
    "グローバルフィルターがクリアされました",
  monitors_create_signal_trigger_detection_mode_warning_2:
    "直近の一致結果がリセットされました",
  monitors_create_signal_trigger_detection_mode_warning_3:
    "Webhook payload が変更されました",
  monitors_create_signal_trigger_detection_mode_switch_to_signal_first:
    "シグナル優先に切り替え",
  monitors_create_signal_trigger_detection_mode_switch_to_company_first:
    "企業優先に切り替え",
  //   create enrichment
  monitors_create_enrichment_header_title: "データ拡張と検証",
  monitors_create_enrichment_header_desc:
    "配信前にシグナルデータを拡張したり、AI 条件で検証したりできます",
  monitors_create_enrichment_company_details_title: "企業詳細",
  monitors_create_enrichment_company_details_cost:
    "1 回の参照あたり 0 クレジット | 1 回の参照あたり 1 クレジット | 1 回の参照あたり {count} クレジット",

  monitors_matched_deliver_company_detail_desc:
    "{destination} に完全な企業プロフィールとして表示されます",

  monitors_create_enrichment_company_details_desc:
    "一致した各シグナルに企業規模、業界、HQ、企業プロフィールを追加します",
  monitors_create_enrichment_company_details_tips:
    "<span>最適な用途</span>：企業の適合性で絞り込みや振り分けを行う場合。対象企業が既に分かっている場合は<span>オフ</span>にします。",

  monitors_create_enrichment_people_search_title: "人物検索",

  monitors_create_enrichment_people_search_cost:
    "1 回の検索あたり 0 クレジット | 1 回の検索あたり 1 クレジット | 1 回の検索あたり {count} クレジット",
  monitors_create_enrichment_people_search_desc:
    "各シグナルに対して 1 件以上の人物検索を実行できます。各検索には独自のフィルターを設定でき、結果は出力内でグループ化されます。",
  monitors_create_enrichment_people_search_tips:
    "<span>最適な用途</span>：自動的に開始したいアウトリーチ向け。どの企業が動いているかを知るだけでよい場合は<span>オフ</span>にします。",
  monitors_create_enrichment_people_search_config_item_max_people_to_return:
    "返却する最大人数",

  monitors_create_enrichment_people_search_config_item_redeem_contact_info:
    "連絡先情報を利用",
  monitors_create_enrichment_people_search_config_item_redeem_credits:
    "1 人あたり 0 クレジット | 1 人あたり 1 クレジット | 1 人あたり {count} クレジット",
  monitors_create_enrichment_people_search_config_add_one: "人物検索を追加",
  monitors_create_enrichment_people_search_config_tips:
    "各検索は独立して実行されます。検索料金は検索ごとに課金され、メールアドレスや電話番号の引き当ては返却された人物ごとに別途課金されます。",
  monitors_create_enrichment_people_search_config_item_advanced_title:
    "<span>詳細フィルター</span>  · 任意",
  monitors_create_enrichment_people_search_config_item_advanced_desc:
    "リストまたはシーケンスに既に含まれる人物に絞り込む",
  monitors_create_enrichment_people_search_config_item_advanced_tips:
    "リストまたはシーケンスに<span>既に</span>含まれる人物のみを返します。空欄のままにすると全員を検索します。再アプローチに便利です。",
  monitors_create_enrichment_people_search_config_item_advanced_label_saved_list:
    "保存済みリストに含まれる",
  monitors_create_enrichment_people_search_config_item_advanced_label_sequence:
    "シーケンスに含まれる",

  // create-delivery
  destination_type: "宛先タイプ",
  monitors_create_delivery_title: "宛先と配信",
  monitors_create_delivery_desc: "シグナルの送信先と配信頻度を定義します",
  monitors_create_delivery_type_next_release: "v2.0",
  webhook: "Webhook",
  monitors_create_delivery_type_webhook_desc:
    "シグナルデータを自社システムやサードパーティツールへ送信します",
  monitors_create_delivery_type_email_title: "メール",
  monitors_create_delivery_type_email_desc:
    "一致したシグナルの読みやすいサマリーをメールで受け取ります",
  monitors_create_delivery_type_sequences_title: "シーケンス",
  monitors_create_delivery_type_sequences_desc:
    "一致した連絡先をアウトリーチシーケンスへ自動登録します",
  monitors_create_delivery_type_sheets_title: "シート",
  monitors_create_delivery_type_sheets_desc:
    "一致したシグナルを希望するデータ宛先へ同期します",

  monitors_create_delivery_configuration_webhook: "Webhook 設定",
  monitors_create_delivery_configuration_email: "メール設定",
  monitors_create_delivery_configuration_sequences: "シーケンス設定",
  monitors_create_delivery_configuration_sheets: "シート設定",

  monitors_create_delivery_email_send_to_label: "送信先",
  monitors_create_delivery_email_send_to_placeholder: "johndoe@example.com",
  monitors_create_delivery_configuration_webhook_endpoint_url:
    "エンドポイント URL",
  monitors_create_delivery_configuration_webhook_endpoint_url_placeholder:
    "https://your-webhook.site",
  monitors_create_delivery_headers: "ヘッダー",
  optional: "任意",
  monitors_create_delivery_add_headers: "ヘッダーを追加",
  monitors_create_delivery_body: "本文パラメータ",
  monitors_create_delivery_add_body: "パラメータを追加",
  monitors_create_key: "キー",
  monitors_create_value: "値",
  monitors_create_delivery_alert_message_label: "障害通知メール",
  monitors_create_delivery_alert_message_placeholder:
    "エンドポイント障害時にこのアドレスへ通知します",
  monitors_create_delivery_run_test_webhook_title: "エンドポイントを検証",
  monitors_create_delivery_run_test_webhook_desc:
    "テストペイロードを送信して、サーバーが正しく受信していることを確認します",
  monitors_create_delivery_run_test_email_title: "メールを検証",
  monitors_create_delivery_run_test_email_desc:
    "テストメールを送信して、アドレスが正しく受信していることを確認します",
  monitors_create_delivery_run_test_button: "テスト送信",

  monitors_create_header_key_placeholder: "例 Authorization",
  monitors_create_header_value_placeholder: "例 Bearer your token",

  //   create preview
  monitors_create_preview_title: "確認して作成",
  monitors_create_preview_desc: "本番化の前に設定内容を確認します",
  monitors_create_preview_define_name_title: "モニター名 ",
  monitors_create_preview_define_name_placeholder:
    "例: マレーシアの営業採用 - 外資系・従業員数 100 名以上",
  monitors_create_preview_tips:
    "API キー（X-Pubrio-Signature）は作成後に生成され、設定タブにすぐ表示されます。",

  monitors_create_preview_summary:
    "このモニターは <span>{companies}</span> の <span>{signals}</span> を監視し、一致した項目を <span>{destination}</span> に送信します（{interval} で確認）。",
  any_matching_companies: "一致するすべての企業",

  // detail settings
  monitor: "モニター",
  monitors: "モニター",
  delivery: "配信",
  sync_interval: "同期頻度",
  sync_interval_description: "新しいシグナルを確認する頻度",
  alert_email: "通知メール",
  alert_email_description:
    "障害が発生した場合や、このモニターが自動停止された場合にメールで通知します",

  failure_handle: "障害処理",
  failure_handle_retry_attempts: "再試行回数",
  failure_handle_retry_attempts_desc:
    "配信を失敗と判定する前に何回再試行するかを設定します",
  failure_handle_retry_delay: "再試行間隔",
  failure_handle_retry_delay_desc:
    "各再試行の間にどれだけ待機するかを設定します",
  failure_handle_auto_pause_failures_count: "連続失敗後に自動停止",
  failure_handle_auto_pause_failures_count_desc:
    "クレジットの無駄を防ぐため、Pubrio がこのモニターを自動的に無効化します。障害通知メールも送信されます",
  failure_handle_daily_trigger_cap: "1 日あたりのトリガー上限",
  failure_handle_daily_trigger_cap_desc:
    "1 日あたりの最大トリガー数です。クレジット消費の制御に役立ちます。0 = 無制限",
  security: "セキュリティ",
  monitors_list_detail_settings_security_api_key_title:
    "API キー（X-Pubrio-Signature）",
  monitors_list_detail_settings_security_api_key_description:
    "サーバーサイドの検証ロジックに追加してください",
  copied: "コピーしました",

  //   detail tabs
  monitors_detail_tab_flow: "フロー",

  // wizard
  getting_started: "はじめに",
  monitors_wizard_introduction_title:
    "シグナルを追跡し、一致した情報を自動でルーティング",
  monitors_wizard_introduction_desc:
    "モニターは採用情報、ニュース、広告、資金調達など、注目したいシグナルを監視し、一致した情報をエンリッチしてあなたが利用する場所へ送信します。3ステップで設定できます。",
  // Wizard guided tour (driver.js)
  monitor_wizard_tour_step_1_title: "ようこそ — 購買シグナルを捉えましょう",
  monitor_wizard_tour_step_1_desc:
    "モニターは採用や資金調達などのシグナルを求めて企業を監視し、一致した瞬間に通知します。最初のモニターを作成しましょう。",
  monitor_wizard_tour_step_2_title: "まず何を監視するか選びましょう",
  monitor_wizard_tour_step_2_desc:
    "重要なシグナルを選択してください：採用、ニュース、広告、事業拡大。いずれかが発生するたびに通知します。",
  monitor_wizard_tour_step_3_title: "形になっていく様子を見てみましょう",
  monitor_wizard_tour_step_3_desc:
    "このライブプレビューは、モニターをパイプラインとして表示します。何がトリガーになり、何を追加し、どこへ送るかが含まれます。",
  monitor_wizard_tour_step_4_title: "活用する情報を追加しましょう",
  monitor_wizard_tour_step_4_desc:
    "企業情報や実際の連絡先をオンにして、すべての一致が単なる名前ではなく、すぐに行動できる状態になるようにします。",
  monitor_wizard_tour_step_5_title: "一致した情報を作業場所へ送りましょう",
  monitor_wizard_tour_step_5_desc:
    "メール、シーケンス、スプレッドシート、または独自のツール。一致した情報を処理する場所を選択してください。",
  monitor_wizard_tour_step_6_title: "何が得られるかを正確に確認しましょう",
  monitor_wizard_tour_step_6_desc:
    "このパネルは各一致が提供する内容を常に表示するので、完了する前に価値を把握できます。",
  monitor_wizard_tour_step_7_title: "準備完了です！作成しましょう！",
  monitor_wizard_tour_step_7_desc:
    "最後の画面を進めて「作成」を押してください。モニターが稼働し、シグナルの捕捉を開始します。",
  monitors_wizard_tips: "設定には約 2 分かかります",
  create_first_monitor: "最初のモニターを作成",

  monitors_trigger_types_str: "求人・ニュース・広告",
  custom_interval: "カスタム間隔",
  monitors_wizard_define_trigger_title: "トリガーを定義",
  monitors_wizard_define_trigger_desc:
    "監視するシグナルを選択し、フィルターを設定して一致条件を絞り込みます。任意の企業全体を対象にすることも、特定企業群に限定することもできます。",
  monitors_wizard_enrich_signal_data_title: "シグナルデータを拡張",
  monitors_wizard_enrich_signal_data_desc:
    "企業詳細を追加したり、人物検索を実行して一致企業の適切な連絡先を見つけたりできます。",
  monitors_wizard_choose_destination_title: "宛先を選択",
  monitors_wizard_choose_destination_desc:
    "一致したシグナルデータを Webhook、メール、または接続済みツールへ送信します。リアルタイムから日次まで同期頻度を設定できます。",
  monitors_wizard_example_title: "モニター例",

  presets: "プリセット",

  // flow
  monitors_flow_company_enrichment: "企業データ拡張",
  destination: "宛先",
  add_filter: "フィルターを追加",
  field: "フィールド",
  operator: "演算子",
  real_time: "リアルタイム",

  monitors_create_company_first_one_company_at_least:
    "監視対象の企業を少なくとも 1 社追加してください。",
  monitors_create_signal_types_one_at_least:
    "続行するには、少なくとも 1 つのシグナル種別を選択してください。",
  monitors_create_validation_signal_types_required:
    "監視するシグナル種別を少なくとも 1 つ選択してください。",
  monitors_create_validation_email_required:
    "宛先メールアドレスを少なくとも 1 つ追加してください。",
  monitors_create_validation_name_required:
    "後で見つけられるように、モニターに名前を付けてください。",

  credits_cost: "0 クレジット | 1 クレジット | {count} クレジット",

  // try
  monitor_try_popover_title: "このモニターを試す",
  monitor_try_popover_desc:
    "実行対象の日付を選択してください。結果が見つかった場合はクレジットが消費されます。",
  monitor_try_popover_form_date_label: "日付",
  monitor_try_popover_max_results_label: "最大結果数",
  run_query: "クエリを実行",
  monitors_try_button: "テストクエリを実行",

  // list aside filters
  last_trigger_at_descending: "最終トリガー（新しい順）",
  last_trigger_at_ascending: "最終トリガー（古い順）",
  name_ascending: "名前（A-Z）",
  name_descending: "名前（Z-A）",

  // signals
  news: "ニュース",
  jobs: "求人",
  signal_types: "シグナル種別",
  news_filter: "ニュースフィルター",
  jobs_filter: "求人フィルター",
  advertisements_filter: "広告フィルター",
  global_filters: "グローバルフィルター",

  company_enrichment_enable_desc: "規模、業界、HQ、プロフィールを追加済み",
  company_enrichment_enable_fields: "規模、業界、HQ、プロフィール",
  off: "オフ",

  max_people_count: "最大 0 人 | 最大 1 人 | 最大 {count} 人",
  "monitor_detail_logs-table-empty-title": "まだログがありません",
  "monitor_detail_logs-table-empty-desc":
    "このモニターがシグナルを受信し始めると、ここにログが表示されます。最初のイベントを発生させるにはテストクエリを実行してください。",

  signal: "シグナル",
  detection: "検出",
  monitor_detail_logs_payload_sent: "送信ペイロード",
  monitor_detail_logs_payload_received: "レスポンス",
  monitor_detail_logs_trigger_config: "トリガー設定",

  create_monitor: "モニターを作成",
  update_monitor: "モニターを更新",

  monitors_edit_title: "モニターを編集",
  global: "グローバル",
  navMonitorsDesc:
    "企業を追跡し、連絡すべきタイミングが来たら通知を受け取りましょう。",

  trigger_limits: "トリガー上限",
  monitor_not_found: "モニターが見つかりません",
  please_select_field_and_operator_first:
    "先にフィールドと演算子を選択してください",

  people_count: "0 人 | 1 人 | {count} 人",
  search_fee: "検索料金 {0} クレジット",
  email_cost: "メール引き当て料金 {0} クレジット",
  phone_cost: "電話番号引き当て料金 {0} クレジット",
  estimated_cost: "見積コスト:",
  monitors_create_enrichment_people_search_config_item_credits_message:
    "見積コスト: 最小 <strong>{0}</strong>、最大 <strong>{1}</strong> = {2}",

  monitor_estimate_cost_title: "トリガーあたりの見積コスト",
  monitor_estimate_cost_max_record:
    "最大 0 レコード | 最大 1 レコード | 最大 {count} レコード",
  credits_cost_range: "{0} クレジット",
  signal_detection: "シグナル検出",
  matched_companies: "一致企業 0 社 | 一致企業 1 社 | 一致企業 {count} 社",
  min_prefix: "最小: ",
  max_prefix: "最大: ",

  recovered: "復旧",
  breakdown: "内訳",
  monitor_estimate_cost_fixed_per_trigger: "トリガーあたりの固定費用",
  credits_cost_short: "0 クレジット | 1 クレジット | {count} クレジット",
  credits_cost_short_per_company:
    "0 クレジット / 社 | 1 クレジット / 社 | {count} クレジット / 社",
  monitor_estimate_cost_per_match_company: "一致企業ごと",
  monitor_estimate_cost_per_company_subtotal: "企業ごとの小計",
  monitor_estimate_cost_redeem_cost: "一致企業ごとの引き当て費用",
  monitor_estimate_cost_redeem_subtotal: "引き当て小計",
  monitor_estimate_cost_redeem_list_name: "PS{0} {1} × {2} 人",
  monitor_estimate_cost_fixed_desc:
    "シグナル検出は固定費用です。一致した企業数に関わらず、トリガーごとに 1 回だけ課金されます。",
  monitor_estimate_cost_fixed: "固定費用",
  redeems: "引き当て",
  company_count_short: "0 社 | 1 社 | {count} 社",

  monitor_sequence_summary_step_count:
    "0 ステップ | 1 ステップ | {count} ステップ",
  monitor_sequence_summary_contact_count:
    "0 件の連絡先 | 1 件の連絡先 | {count} 件の連絡先",
  search_sequence: "シーケンスを検索",
  create_new_sequence: "新しいシーケンスを作成",
  draft: "下書き",

  monitors_create_delivery_sequence_who_enrolled_title: "登録対象",
  monitors_create_delivery_sequence_edit_in_enrichment: "データ拡張で編集",
  monitors_create_delivery_sequence_who_enrolled_tip:
    "データ拡張で設定されたソースです。シーケンス登録のために各項目をオン・オフに切り替えてください。条件はここではなくデータ拡張で設定します。",
  monitor_create_delivery_sequence_company_contact: "企業連絡先",
  monitor_create_delivery_sequence_company_contact_desc:
    "最適マッチプロフィール · 企業プロフィールより",
  enrolling: "登録中",
  not_enrolling: "登録しない",
  monitor_sequence_who_enrolled_people_title: "人物 - 人物検索より",

  monitor_create_delivery_sequence_enroll_behavior_title: "登録動作",
  monitor_create_delivery_sequence_enroll_behavior_desc:
    "各連絡先シナリオで何が起こるかを定義します。すべてのルールは登録済みのすべてのソースに適用されます。",

  monitor_create_delivery_sequence_enroll_behavior_new_contact_title:
    "新規連絡先",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_desc:
    "このシーケンスにまだ登録されていません",
  start_at: "開始ステップ",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_placeholder:
    "例: ステップ 1 またはステップ 2",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_title:
    "対象シーケンスに登録済み",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_desc:
    "このモニターが使用する同じシーケンスでアクティブ",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_placeholder:
    "例: ステップ 1 から再開",
  skip: "スキップ",
  people_search: "人物検索",
  no_config_in_enrichment: "データ拡張で設定されていません",
  fetch_sequence_steps_failed: "シーケンスステップの取得に失敗しました",
  monitor_create_delivery_sequence_enroll_behavior_new_contact_option:
    "ステップ {index} - {step}",
  monitor_create_delivery_sequence_enroll_behavior_exist_contact_option:
    "ステップ {index} - {step} から再開",

  // 日本語
  monitors_matched_deliver_signal_title: "企業とシグナル",
  monitors_matched_deliver_signal_desc:
    "企業名と、一致のきっかけとなったシグナル",
  monitors_matched_deliver_people_search_desc:
    "メールに氏名、役職、連絡先情報とともに記載されます",
  monitors_matched_deliver_title: "各一致で得られるもの",
  to_somewhere: "{destination} へ",
  monitor_create_delivery_sequence_people_contact: "人物連絡先",
  monitor_create_delivery_sequence_people_contact_desc:
    "すべての有効な人物検索ブロックから",
  selected_sequence_not_exist: "選択したシーケンスは存在しません",
  monitors_create_delivery_sequence_enrichment_invalid:
    "人物連絡先、会社連絡先、または両方を登録してください。",
  monitors_create_delivery_sequence_required:
    "続行するにはシーケンスを選択してください。",
  failing: "失敗",
  monitor_create_delivery_sequence_warning_title: "不明なシーケンス",
  monitor_create_delivery_sequence_warning_desc:
    "シーケンスが削除されました — 代替を選択してください",
  deleted: "削除済み",
  owner: "オーナー",
  not_triggered_yet: "まだトリガーされていません",
};
